webpackJsonp([1],{

/***/ "/Se+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Suc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EoUh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d537ae3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("SU9I")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-7d537ae3"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b14104b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("/Se+")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef52442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("/Suc")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a70983b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("bMw6")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9212cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("EoUh")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XXI N⁰. 111",
  "shortTitle": "",
  "description": "",
  "width": 1532,
  "height": 1149,
  "currentLanguage": "ES",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://escrime-xxi.fie.org/111/en/"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://escrime-xxi.fie.org/111/fr/"
  }, {
    "code": "ES",
    "text": "Spanish",
    "href": "http://escrime-xxi.fie.org/111/es/"
  }],
  "basePath": "/111/es",
  // "basePath": "",
  "companyLogo": "1-numerals.png",
  "publishURL": "http://escrime-xxi.fie.org/111/es/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "mobileSwitch": true,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n\n        <img id=\"1-0\" class=\"halfScale\" style=\"top:1px;left:371px\" src=\"/111/es/static/_content/1-numerals.png\">\n\n        <img id=\"1-1\" class=\"halfScale\" style=\"top:110px;left:69px\" src=\"/111/es/static/_content/1-title.png\">\n        <img id=\"1-2\" class=\"halfScale\" style=\"top:276px;left:68px\" src=\"/111/es/static/_content/1-sub-1.png\">\n\n        <img id=\"1-3\" class=\"halfScale\" style=\"top:111px;left:1076px\" src=\"/111/es/static/_content/1-no.png\">\n\n        <img id=\"1-text-1\" class=\"halfScale pointer\" style=\"top:740px;left:0px\" onclick=\"Publish.goToPage(11)\" src=\"/111/es/static/_content/1-sub-2.png\">\n        <img id=\"1-text-2\" class=\"halfScale pointer\" style=\"top:860px;left:0px\" onclick=\"Publish.goToPage(30)\" src=\"/111/es/static/_content/1-sub-3.png\">\n        <img id=\"1-text-3\" class=\"halfScale pointer\" style=\"top:966px;left:0px\" onclick=\"Publish.goToPage(26)\" src=\"/111/es/static/_content/1-sub-4.png\">\n\n        <img id=\"1-4\" class=\"halfScale pointer\" style=\"top:988px;left:1442px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/1-arrow.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n          .fromTo(idOf(\"1-1\"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)\n          .fromTo(idOf(\"1-0\"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},\"-=0.2\")\n          .fromTo(idOf(\"1-2\"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-3\"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-text-1\"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-2\"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-3\"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-4\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1})\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "N˚111 REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  GRAN PREMIO SEÚL A CALI ENTREVISTA CON ELI DERSHWITZ CAMPEONATOS DEL MUNDO BUDAPEST 2019  Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista",
    "mobileHtml": "\n      <img src=\"/111/es/static/_mobile/1.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"halfScale 2-title\" style=\"top:109px;left:81px\" src=\"/111/es/static/_content/2-title.png\">\n\n      <img class=\"halfScale 2-icons\" style=\"top:863px;left:157px\" src=\"/111/es/static/_content/2-pop.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:459px\" src=\"/111/es/static/_content/2-play.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:829px\" src=\"/111/es/static/_content/2-soc.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:1116px\" src=\"/111/es/static/_content/2-no.png\">\n\n      <img class=\"halfScale pointer howto-desktop\" style=\"top:125px;left:1074px;opacity:1;\" onclick=\"switchPopHowto(true)\" src=\"/111/es/static/_content/2-desktop-btn.png\">\n      <img class=\"halfScale pointer howto-ipad\" style=\"top:125px;left:1275px;opacity:0\" onclick=\"switchPopHowto(false)\" src=\"/111/es/static/_content/2-ipad-btn.png\">\n\n      <img class=\"howto-desktop\" style=\"top:257px;left:71px;\" src=\"/111/es/static/_content/2-desktop.png\">\n      <img class=\"howto-ipad\" style=\"top:247px;left:71px;display:none;\" src=\"/111/es/static/_content/2-ipad.png\">\n\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax()\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .staggerFromTo(cOf(\"2-icons\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, \"-=0.2\")\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "INSTRUC CIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  EXPLORAR Utilice las flechas del teclado para desplazarse horizontalmente por la revista  Navegación  Para ver la revista, utilice las flechas del teclado para desplazarse a la izquierda y a la derecha por toda la publicación.  EXPLORADOR DE INTERNET Para obtener los mejores resultados, recomendamos el uso de Safari o Google Chrome.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"bottom:25px;right:40px;width:280px; height:30px;\">\n          <a href=\"http://tissotwatches.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.tissotwatches.com\" target=\"_blank\">\n        <img src=\"/111/es/static/_mobile/3.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div class=\"addContentLink\" style=\"top: 191px; left:80px;width:145px; height: 35px;\">\n          <a href=\"http://www.fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top: 75px; right:623px;width:55px; height: 55px;\">\n          <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top:130px; right:623px;width:55px; height: 55px;\">\n          <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\"></a></div>\n\n        <img id=\"4-title\" class=\"halfScale\" style=\"top:61px;left:87px\" src=\"/111/es/static/_content/4-title.png\">\n\n        <img id=\"fourIpad\" class=\"cont-item-0-link\" style=\"top:385px;left:591px\" src=\"/111/es/static/_content/4-pop-1.png\">\n        <img class=\"cont-item cont-item-1-btn halfScale\" style=\"top:327px;left:572px;opacity:0\" src=\"/111/es/static/_content/4-pop-2.png\">\n        <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:338px;left:574px;opacity:0\" src=\"/111/es/static/_content/4-pop-3.png\">\n        <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:358px;left:574px;opacity:0\" src=\"/111/es/static/_content/4-pop-4.png\">\n        <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:351px;left:574px;opacity:0\" src=\"/111/es/static/_content/4-pop-5.png\">\n        <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:327px;left:574px;opacity:0\" src=\"/111/es/static/_content/4-pop-6.png\">\n        <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:358px;left:574px;opacity:0\" src=\"/111/es/static/_content/4-pop-7.png\">\n\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:940px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/4-arrow.jpg\">\n\n        <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top:358px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top:450px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(3);\" style=\"top:543px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top:635px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top:727px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top:819px; left:84px; width: 492px; height: 60px;\"></div>\n\n        <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\" style=\"top:357px;left:573px;width:638px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\" style=\"top:357px;left:646px;width:708px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(11)\" style=\"top:450px;left:574px;width:776px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(16)\" style=\"top:541px;left:646px;width:708px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(19)\" style=\"top:633px;left:646px;width:708px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(26)\" style=\"top:726px;left:646px;width:708px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(30)\" style=\"top:541px;left:574px;width:597px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(32)\" style=\"top:350px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(36)\" style=\"top:449px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(38)\" style=\"top:540px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(42)\" style=\"top:633px;left:573px;width:804px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(45)\" style=\"top:725px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(47)\" style=\"top:810px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(50)\" style=\"top:900px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(53)\" style=\"top:990px;left:646px;width:731px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(56); setTimeout(function(){showOverlay('58-pop-1');}, 200)\" style=\"top:450px;left:646px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(56); setTimeout(function(){showOverlay('58-pop-2');}, 200)\" style=\"top:541px;left:646px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(56); setTimeout(function(){showOverlay('58-pop-3');}, 200)\" style=\"top:632px;left:646px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(56); setTimeout(function(){showOverlay('58-pop-4');}, 200)\" style=\"top:727px;left:574px;width:778px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(56); setTimeout(function(){showOverlay('58-pop-5');}, 200)\" style=\"top:817px;left:646px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(58)\" style=\"top:818px;left:574px;width:413px;height:64px;display:none;\"></div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n\n        pg4Anim.fromTo(idOf(\"4-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)\n        .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n      }\n\n\n      function contentsBub(index){\n        TweenMax.to(cOf(\"cont-hide\"), 0.5, {opacity:0})\n        console.log(\"contentsBub\", index)\n        for(var i=0; i <= 6; i++){\n          if(i == index){\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n              console.log(c)\n              c.style.display = \"\";\n            },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:1, onComplete:function(){\n\n              classc(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n              if(classc(\"cont-item-\"+index+\"-link\")[1]){\n                classc(\"cont-item-\"+index+\"-link\")[1].style.display = \"\"\n              }\n            }});\n          }else{\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"none\";\n              },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:0});\n            TweenMax.to(idOf(\"fourIpad\"), 0.5, {opacity:0});\n          }\n        }\n      }\n\n      function onPageLeave() {\n        pg4Anim.stop()\n        removeContentLinks();\n        contentsBub(0);\n        TweenMax.to(idOf('fourIpad'), 0.1, {opacity:1});\n      }\n      ",
    "searchText": "ÍNDICE  EN ESTE NÚMERO WWW.FIE.ORG  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada  EDITORIAL  DEPORTE  Pulse los botones para revelar el contenido  ENTREVISTA NOTICIAS DE LA FIE Y DE LAS FEDERACIÓNES NACIONALES  NOTICIAS  NECROLÓGICAS  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n      <img class=\"halfScale pointer 5-arrow\" style=\"top:854px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/5-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:54px\" src=\"/111/es/static/_content/5-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:124px\" src=\"/111/es/static/_content/5-social-fb.png\">\n      </a>\n      <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:192px\" src=\"/111/es/static/_content/5-social-yt.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"bottom:242px;left:745px;width:100px;height:26px;\">\n        <a href=\"mailto:info@fie.ch\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"bottom:213px;left:686px;width:105px;height:26px;\">\n          <a href=\"http://www.fie.org\" target=\"_blank\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"bottom:155px;right:313px;width:212px;height:30px;\">\n          <a href=\"http://www.touchline.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax()\n          pg5Anim.fromTo(cOf(\"5-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "C OMITÉ E JECUTIVO DE L A FIE  Presidente: Alisher Usmanov (RUS) Secretario general: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  OFICINA CENTRAL DE LA FIE  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Miembros: Erika Aze (LAT) Jacek Bierkowski (POL) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Wei Wang (CHN) Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)  Administración  Directora general Nathalie Rodriguez M.-H. (FRA)  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA) Jefe de operaciones: Elena Huot (RUS) Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Manager de operaciones del deporte: Sophie Treyvaud (SUI) Comunicación, Marketing, TV  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: Celso L. Dayrit (M.H.) (PHI) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Jefe del gabinete del presidente: Nina Lalovic (SRB)  Manager digital y de comunicaciónes: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Diseño Touchline (www.touchline.com)  W W W.FIE .ORG",
    "mobileHtml": "\n        <p>\n        <b>President</b>:<br> Alisher Usmanov (RUS)<br>\n        <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>\n        <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>\n        <p>\n        <b>Vice Presidents</b>:<br>\n        Ana Pascu (M.H.) (ROU)<br>\n        Donald Anthony (USA)<br>\n        Yuki Ota (JPN)<br></p>\n        <p>\n        <b>Members</b>:<br>\n        Erika Aze (LAT)<br>\n        Jacek Bierkowski (POL)<br>\n        Velichka Hristeva (BUL)<br>\n        Isabelle Lamour (FRA)<br>\n        Novak Perovic (RSA)<br>\n        Oleg Peskov (KAZ)<br>\n        Giorgio Scarso (ITA)<br>\n        Bence Szabo (HUN)<br>\n        Pascal Tesch (LUX)<br>\n        Wei WANG (CHN)<br>\n        Aldo Montano President of the FIE athletes commission (ITA)<br></p>\n\n        <p>\n          <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>\n          <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>\n          <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>\n          <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>\n          <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>\n        </p>\n\n        <h2>FIE Head Office</h2>\n        <p>\n        <b>Chief Executive Officer</b><br>\n        Nathalie Rodriguez M.-H. (FRA)\n        </p>\n\n        <h2>Administration</h2>\n        <p>\n        <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>\n        <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>\n        <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>\n        <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>\n        <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>\n        </p>\n\n        <h2>Sport</h2>\n        <p>\n        <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>\n        <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>\n        <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>\n        </p>\n        <h2>Communication, Marketing, TV</h2>\n        <p>\n        <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>\n        <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>\n        <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>\n        <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>\n        <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>\n        <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>\n        </p>\n\n        <h2>Design</h2>\n        <p>\n        Touchline </b><br>\n        (<a href=\"http://www.touchline.com\" target=\"blank\">www.touchline.com</a>)\n        </p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n        <img id=\"6-img\" class=\"halfScale\" style=\"top:188px;left:409px\" src=\"/111/es/static/_content/6-img.jpg\">\n        <img id=\"6-title\" class=\"halfScale\" style=\"top:728px;left:159px\" src=\"/111/es/static/_content/6-title.png\">\n\n        <img id=\"6-text-1\" class=\"halfScale\" style=\"top:186px;left:766px\" src=\"/111/es/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale\" style=\"top:189px;left:202px; opacity:0;\" src=\"/111/es/static/_content/6-text-2.png\">\n\n        <img id=\"6-cta-1\" class=\"halfScale pointer\" style=\"top:819px;left:783px\" onclick=\"toggleText6(false);\" src=\"/111/es/static/_content/6-btn-1.png\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer\" style=\"top:819px;left:1062px;opacity:0\" onclick=\"toggleText6(true);\" src=\"/111/es/static/_content/6-btn-2.png\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:938px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/6-arrow.jpg\">\n      ",
    "script": "\n      function onPageEnter(){\n        pg6Anim = new TimelineMax();\n        pg6Anim.fromTo(idOf(\"6-img\"), 0.5,{opacity:0}, {opacity:1},0.5)\n            .fromTo(idOf(\"6-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(idOf(\"6-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},\"+=0.3\")\n      }\n\n      function toggleText6(bool){\n        var text1 = idOf(\"6-text-1\");\n        var text2 = idOf(\"6-text-2\");\n\n        if(!bool && text1.style.opacity == \"0\"){\n          pg6Anim.play();\n          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:0}, {opacity:1});\n        }else if(bool && text2.style.opacity == \"0\"){\n          pg6Anim.pause();\n          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:1}, {opacity:0});\n        }\n      }\n\n      function onPageLeave(){\n        if(idOf(\"6-text-1\").style.opacity == \"0\"){\n          toggleText6(false);\n        }\n        pg6Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "PRÓLO GO  Estimados amigos: El año preolímpico de 2019 estuvo lleno de grandes eventos. En abril, nos reunimos en Torun, Polonia, para celebrar los logros de nuestras futuras estrellas en los Campeonatos del Mundo de Esgrima juvenil y cadete. 1300 atletas de 96 países vinieron a Torun a competir por las medallas más valiosas. 18 de ellos se convirtieron en los nuevos campeones del mundo. Alrededor de 700 000 personas siguieron los acontecimientos a través de nuestros canales digitales.  EL CAMINO HACIA TOKIO 2020 COMIENZA AQUÍ  Al final de abril llegó el comienzo del periodo de clasificación olímpica con el Gran Premio de sable de Seúl. Esto continuará hasta el 4 de abril de 2020, fecha en la que se cerrará el periodo de clasificación con el Gran Premio de sable de  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG",
    "mobileHtml": "\n        <h2>EL CAMINO HACIA TOKIO 2020 COMIENZA AQU\xCD</h2>\n\n        <img id=\"fwdimg\" src=\"/111/es/static/_mobile/6-img.jpg\">\n\n        <p><b>Estimados amigos:</b></p>\n\n        <p>El a\xF1o preol\xEDmpico de 2019 estuvo lleno de grandes eventos.</p>\n\n        <p>En abril, nos reunimos en Torun, Polonia, para celebrar los logros de nuestras futuras estrellas en los Campeonatos del Mundo de Esgrima juvenil y cadete. 1300 atletas de 96 pa\xEDses vinieron a Torun a competir por las medallas m\xE1s valiosas. 18 de ellos se convirtieron en los nuevos campeones del mundo. Alrededor de 700 000 personas siguieron los acontecimientos a trav\xE9s de nuestros canales digitales.</p>\n\n        <p>Al final de abril lleg\xF3 el comienzo del periodo de clasificaci\xF3n ol\xEDmpica con el Gran Premio de sable de Se\xFAl. Esto continuar\xE1 hasta el 4 de abril de 2020, fecha en la que se cerrar\xE1 el periodo de clasificaci\xF3n con el Gran Premio de sable de Budapest. Pr\xF3ximamente, lanzaremos el portal Road to Tokyo de la FIE, donde podr\xE1 seguir el progreso de los atletas en la b\xFAsqueda de uno de los puestos m\xE1s codiciados.</p>\n\n        <p>En junio, se celebrar\xE1n los Campeonatos Continentales. \xC1frica se reuni\xF3 en Bamako, Mal\xED, Europa en Dusseldorf, Alemania, y la Federaci\xF3n Panamericana en Toronto, Canad\xE1. El Campeonato Asi\xE1tico se celebr\xF3 en Chiba, Jap\xF3n, cerca de Tokio. Las pruebas individuales se retransmitieron en directo en Eurosport y en el canal digital de la FIE. Esto nos permiti\xF3 preparar una base de retransmisi\xF3n para los Juegos Ol\xEDmpicos de 2020.</p>\n\n        <p>Este a\xF1o, lanzaremos el sitio web actualizado de la FIE, con un dise\xF1o y una estructura nuevos.</p>\n\n        <p>Ahora, los \xFAltimos Campeonatos del Mundo de este ciclo ol\xEDmpico, que se celebraron en Budapest, ya han concluido. Fue un evento memorable. Al igual que en 2013, el campeonato se organiz\xF3 a la perfecci\xF3n. Hemos sido testigos de combates espectaculares entre los mejores tiradores del mundo.</p>\n\n        <p>Para resumir la temporada deportiva saliente, creo que es algo de lo que estar orgulloso y por lo que merece la pena el esfuerzo. Cada a\xF1o, nuestro deporte atrae cada vez m\xE1s espectadores y aficionados.</p>\n\n        <p>Agradezco a todos su participaci\xF3n y su apoyo a la FIE durante la temporada 2019 y les deseo a todas las federaciones nacionales, a los atletas y los entrenadores mucho \xE9xito en el a\xF1o ol\xEDmpico 2020.</p>\n\n        <p><b>Alisher Usmanov<br>Presidente de la FIE</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:80px;right:680px;width:480px; height:48px;\">\n          <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.absolutefencinggear.com\">\n        <img src=\"/111/es/static/_mobile/7.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-title\" style=\"top:112px;left:85px\" src=\"/111/es/static/_content/8-title.png\">\n\n      <img class=\"halfScale 8-line\" style=\"top:368px;left:90px\" src=\"/111/es/static/_content/8-line.png\">\n\n      <img class=\"halfScale 8-sub\" style=\"top:366px;left:132px\" src=\"/111/es/static/_content/8-sub.png\">\n\n      <img class=\"halfScale pointer 8-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax()\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA J ÚNIOR Y CADE TE  ATLETAS ADOLESCENTES COMPITEN EN POLONIA TORUN, POLONIA DEL 6 AL 14 DE ABRIL",
    "mobileHtml": "\n        <h2>ATLETAS ADOLESCENTES COMPITEN EN POLONIA</h2>\n        <img id=\"fwdimg\" src=\"/111/es/static/_mobile/8.jpg\">\n        <p><b>TORUN, POLONIA<br>\n        DEL 6 AL 14 DE ABRIL<br>\n        </b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 9-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax()\n          pg9Anim\n            .fromTo(cOf(\"9-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JÚNIOR Y CADETE TORUN, POLONIA 2/3  Los atletas adolescentes viajaron al norte de Polonia y a la ciudad de Torun, hogar de Copérnico, para competir en 18 pruebas individuales y por equipos en espada, florete y sable en los Campeonatos del Mundo de Esgrima Junior y Cadete en abril de 2019. Con 1420 tiradores participando en el Campeonato, que se llevó a cabo en la Arena Torun de la Ciudad, el exitoso evento duró 9 días en los que los jóvenes tuvieron tiempo para competir, socializar, aprender y desarrollar sus habilidades en esgrima en un lugar de clase mundial. «Hemos visto muchos nuevos tiradores y campeones, muchos de los cuales estoy seguro que veremos en un futuro próximo en las categorías senior», dijo Emmanuel Katsiadakis, Secretario General de la FIE. El Campeonato comenzó con la concentración anual de esgrima de la FIE, que dio a los tiradores de diferentes países la oportunidad de entrenarse entre sí, junto con entrenadores de clase mundial y algunos tiradores senior. Los miembros de la Comisión de Atletas de la FIE,",
    "mobileHtml": "\n      <p><b>Los atletas adolescentes viajaron al norte de Polonia y a la ciudad de Torun, hogar de Cop\xE9rnico, para competir en 18 pruebas individuales y por equipos en espada, florete y sable en los Campeonatos del Mundo de Esgrima Junior y Cadete en abril de 2019.</b></p>\n\n      <p>Con 1420 tiradores participando en el Campeonato, que se llev\xF3 a cabo en la Arena Torun de la Ciudad, el exitoso evento dur\xF3 9 d\xEDas en los que los j\xF3venes tuvieron tiempo para competir, socializar, aprender y desarrollar sus habilidades en esgrima en un lugar de clase mundial.</p>\n\n      <p>Hemos visto muchos nuevos tiradores y campeones, muchos de los cuales estoy seguro que veremos en un futuro pr\xF3ximo en las categor\xEDas senior, dijo Emmanuel Katsiadakis, Secretario General de la FIE.</p>\n\n      <p>El Campeonato comenz\xF3 con la concentraci\xF3n anual de esgrima de la FIE, que dio a los tiradores de diferentes pa\xEDses la oportunidad de entrenarse entre s\xED, junto con entrenadores de clase mundial y algunos tiradores senior. Los miembros de la Comisi\xF3n de Atletas de la FIE, reunidos en Torun y dirigidos por su presidente y medallista de oro ol\xEDmpico italiano Aldo Montano, pasaron tiempo con los participantes del campamento. Entre ellos se encontraban Benjamin Kleibrink (GER), Gbahi Gwladys Sakoa (CIV) y Maria Luisa Doig (PER).</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 10-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/10-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('10-pop')\" style=\"top:855px;left:59px\" src=\"/111/es/static/_content/trophy-red.png\">\n\n      <div id=\"10-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/10-pop.png\">\n        <a href=\"https://fie.org/competitions/2019/230?tab=results\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse\" style=\"top:915px;left:940px\" src=\"/111/es/static/_content/trophy-white.png\">\n        </a>\n          <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('10-pop');\"></div>\n        <img id=\"10-sabre\" class=\"halfScale 10-events\" style=\"top:336px;left:269px;opacity:1\" src=\"/111/es/static/_content/10-sabre.png\">\n        <img id=\"10-foil\" class=\"halfScale 10-events\" style=\"top:383px;left:269px; opacity:0\" src=\"/111/es/static/_content/10-foil.png\">\n        <img id=\"10-epee\" class=\"halfScale 10-events\" style=\"top:384px;left:269px; opacity:0\" src=\"/111/es/static/_content/10-epee.png\">\n\n        <div class=\"contentLink\" style=\"top:336px;left:269px;height:189px;width:113px;\" onclick=\"toggleCategory('10-sabre', '10-events')\" src=\"/111/es/static/_content/10-sabre.png\"></div>\n        <div class=\"contentLink\" style=\"top:529px;left:269px;height:189px;width:113px;\" onclick=\"toggleCategory('10-foil', '10-events')\" src=\"/111/es/static/_content/10-foil.png\"></div>\n        <div class=\"contentLink\" style=\"top:723px;left:269px;height:189px;width:113px;\" onclick=\"toggleCategory('10-epee', '10-events')\" src=\"/111/es/static/_content/10-epee.png\"></div>\n\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax()\n          pg10Anim\n            .fromTo(cOf(\"10-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop()\n          hideOverlay('10-pop');\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JÚNIOR Y CADETE TORUN, POLONIA 3/3  reunidos en Torun y dirigidos por su presidente y medallista de oro olímpico italiano Aldo Montano, pasaron tiempo con los participantes del campamento. Entre ellos se encontraban Benjamin Kleibrink (GER), Gbahi Gwladys Sakoa (CIV) y Maria Luisa Doig (PER). Se llevaron a cabo numerosos programas educativos e informativos en los Campeonatos en beneficio de tiradores, entrenadores y otros, incluyendo el Deporte Seguro, el Juego Limpio y el Deporte Limpio/antidopaje. Además, el programa continuo de la FIE «Donate  Your Fencing Gear» estaba en pleno funcionamiento en el Campeonato, reuniendo una cantidad diversa y generosa de equipos de buena calidad donados por atletas y entrenadores para beneficiar a las federaciones y atletas que los necesitaban.  Pulse aquí para ver los MEDALLISTAS DE ORO  Rusia se llevó el mayor número de medallas de oro (cinco) de los 18 eventos, seguida de Italia y Hungría (cuatro cada una). Italia se llevó el mayor número de medallas, 18 en total. Aquí se presente la lista de medallistas en pruebas individuales y por equipos. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p>Se llevaron a cabo numerosos programas educativos e informativos en los Campeonatos en beneficio de tiradores, entrenadores y otros, incluyendo el Deporte Seguro, el Juego Limpio y el Deporte Limpio/antidopaje. Adem\xE1s, el programa continuo de la FIE <<Donate Your Fencing Gear>> estaba en pleno funcionamiento en el Campeonato, reuniendo una cantidad diversa y generosa de equipos de buena calidad donados por atletas y entrenadores para beneficiar a las federaciones y atletas que los necesitaban.</p>\n\n      <p>Rusia se llev\xF3 el mayor n\xFAmero de medallas de oro (cinco) de los 18 eventos, seguida de Italia y Hungr\xEDa (cuatro cada una). Italia se llev\xF3 el mayor n\xFAmero de medallas, 18 en total. Aqu\xED se presente la lista de medallistas en pruebas individuales y por equipos.</p>\n\n      <h2>MEDALLISTAS DE ORO</h2>\n      <p>Los medallistas de oro individuales y por equipo de los tres eventos incluyen lo siguiente:</p>\n\n      <h4>SABLE</h4>\n      <p>Fecha\tG\xE9nero - Categor\xEDa\tEvento - <b>Medallistas</b></p>\n      <p>6 Apr - Hombres\tJ\xFAnior - Individual: <br><b>Lorenzo Roma (ITA)</b></p>\n      <p>6 Apr - Mujeres\tJ\xFAnior - Individual: <br> <b>Alina Mikhailova (RUS)</b></p>\n\n      <p>7 Apr - Hombres\tCadete - Individual:<br> <b>Vasyl Humen (UKR)</b></p>\n      <p>7 Apr - Mujeres\tCadete - Individual:<br> <b>Luca Szucs (HUN)</b></p>\n\n      <p>8 Apr - Hombres\tJ\xFAnior - Equipos:<br> <b>Italia</b></p>\n      <p>8 Apr - Mujeres\tJ\xFAnior - Equipos:<br> <b>Hungr\xEDa</b></p>\n\n      <h4>FLORETE</h4>\n      <p>Fecha\tG\xE9nero - Categor\xEDa\tEvento - <b>Medallistas</b></p>\n      <p>9 Apr - Hombres\tJ\xFAnior - Individual:<br> <b>Kirill Borodachev (RUS)</b></p>\n      <p>9 Apr - Mujeres\tJ\xFAnior - Individual:<br> <b>Lauren Scruggs (USA)</b></p>\n\n      <p>10 Apr - Hombres\tCadete - Individual:<br> <b>Egor Barannikov (RUS)</b></p>\n      <p>10 Apr - Mujeres\tCadete - Individual:<br> <b>Lauren Scruggs (USA)</b></p>\n\n      <p>11 Apr - Hombres\tJ\xFAnior - Equipos:<br> <b>Russia</b></p>\n      <p>11 Apr - Mujeres\tJ\xFAnior - Equipos:<br> <b>Russia</b></p>\n\n      <h4>ESPADA</h4>\n      <p>Fecha\tG\xE9nero - Categor\xEDa\tEvento - <b>Medallistas</b></p>\n      <p>12 Apr - Hombres\tJ\xFAnior - Individual:<br> <b>Arthur Philippe (FRA)</b></p>\n      <p>12 Apr - Mujeres\tJ\xFAnior - Individual:<br> <b>Federica Isola (ITA)</b></p>\n\n      <p>13 Apr - Hombres\tCadete - Individual:<br> <b>Enrico Piatti (ITA)</b></p>\n      <p>13 Apr - Mujeres\tCadete - Individual:<br> <b>Eszter Muhari (HUN)</b></p>\n\n      <p>14 Apr - Hombres\tJ\xFAnior - Equipos:<br> <b>Hungary</b></p>\n      <p>14 Apr - Mujeres\tJ\xFAnior - Equipos:<br> <b>France</b></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 11-title\" style=\"top:73px;left:529px\" src=\"/111/es/static/_content/11-title.png\">\n\n      <img class=\"halfScale 11-line\" style=\"top:409px;left:541px\" src=\"/111/es/static/_content/11-line.png\">\n\n      <img class=\"halfScale 11-sub\" style=\"top:409px;left:585px\" src=\"/111/es/static/_content/11-sub.png\">\n\n      <img class=\"halfScale pointer 11-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax()\n          pg11Anim.fromTo(cOf(\"11-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"11-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"11-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"11-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop()\n        }\n      ",
    "searchText": "GR AN PREMIO  EL GRAN PREMIO DE LA FIE COMPLETA LA SERIE MUNDIAL DE LA TEMPORADA MAYO DE 2019",
    "mobileHtml": "\n        <h2>EL GRAN PREMIO DE LA FIE COMPLETA LA SERIE MUNDIAL DE LA TEMPORADA</h2>\n        <img id=\"fwdimg\" src=\"/111/es/static/_mobile/11.jpg\">\n        <p><b>MAYO DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 12-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax()\n          pg12Anim\n            .fromTo(cOf(\"12-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop()\n        }\n      ",
    "searchText": "GRAN PREMIO TEMPORADA 2018-2019 2/3  La temporada 2018-2019 del Gran Premio de la FIE compuesta por nueve eventos alrededor del mundo, se ha completado con seis de los nueve torneos celebrados entre marzo y mayo. Con la inminente celebración de los Campeonatos del Mundo de Budapest en julio, y con la intención de clasificarse para los Juegos Olímpicos de Tokio 2020, la competición en los eventos se vio animada por emocionantes combates y por una mezcla de nuevos y conocidos talentos de la esgrima en las pistas de la fase final.",
    "mobileHtml": "\n      <p><b>La temporada 2018-2019 del Gran Premio de la FIE compuesta por nueve eventos alrededor del mundo, se ha completado con seis de los nueve torneos celebrados entre marzo y mayo.</b></p>\n      <p>Con la inminente celebraci\xF3n de los Campeonatos del Mundo de Budapest en julio, y con la intenci\xF3n de clasificarse para los Juegos Ol\xEDmpicos de Tokio 2020, la competici\xF3n en los eventos se vio animada por emocionantes combates y por una mezcla de nuevos y conocidos talentos de la esgrima en las pistas de la fase final.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 13-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/10-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('13-pop')\" style=\"top:855px;left:59px\" src=\"/111/es/static/_content/trophy-red.png\">\n\n      <div id=\"13-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/10-pop.png\">\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse\" style=\"top:915px;left:940px\" src=\"/111/es/static/_content/trophy-white.png\">\n        </a>\n        <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('13-pop');\"></div>\n        <img id=\"13-sabre\" class=\"halfScale 13-events\" style=\"top:336px;left:269px;opacity:1\" src=\"/111/es/static/_content/13-sabre.png\">\n        <img id=\"13-foil\" class=\"halfScale 13-events\" style=\"top:383px;left:269px; opacity:0\" src=\"/111/es/static/_content/13-foil.png\">\n        <img id=\"13-epee\" class=\"halfScale 13-events\" style=\"top:384px;left:269px; opacity:0\" src=\"/111/es/static/_content/13-epee.png\">\n\n        <div class=\"contentLink\" style=\"top:336px;left:269px;height:189px;width:113px;\" onclick=\"toggleCategory('13-sabre', '13-events')\" src=\"/111/es/static/_content/13-sabre.png\"></div>\n        <div class=\"contentLink\" style=\"top:529px;left:269px;height:189px;width:113px;\" onclick=\"toggleCategory('13-foil', '13-events')\" src=\"/111/es/static/_content/13-foil.png\"></div>\n        <div class=\"contentLink\" style=\"top:723px;left:269px;height:189px;width:113px;\" onclick=\"toggleCategory('13-epee', '13-events')\" src=\"/111/es/static/_content/13-epee.png\"></div>\n\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax()\n          pg13Anim\n            .fromTo(cOf(\"13-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          hideOverlay('13-pop');\n        }\n      ",
    "searchText": "GRAN PREMIO TEMPORADA 2018-2019 3/3  Pulse aquí para ver los MEDALLISTAS DE ORO  Cada característica del Gran Premio es específica para cada arma, con hombres y mujeres combatiendo individualmente (no se realizan eventos por equipos en los eventos del Gran Premio). Las ubicaciones en estos seis eventos incluyeron Budapest (espada), Anaheim (florete), Seúl (sable), Cali (espada), Shanghai (florete) y Moscú (sable). Los ganadores reciben más puntos en un Gran Premio que en una competición de copa del mundo, por lo que, en general, las apuestas son más altas. Para muchos tiradores, hacer un buen trabajo en un Gran Premio puede marcar la diferencia en la clasificación para un equipo nacional y formar parte de los Campeonatos del Mundo. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p>Cada caracter\xEDstica del Gran Premio es espec\xEDfica para cada arma, con hombres y mujeres combatiendo individualmente (no se realizan eventos por equipos en los eventos del Gran Premio). Las ubicaciones en estos seis eventos incluyeron Budapest (espada), Anaheim (florete), Se\xFAl (sable), Cali (espada), Shanghai (florete) y Mosc\xFA (sable). Los ganadores reciben m\xE1s puntos en un Gran Premio que en una competici\xF3n de copa del mundo, por lo que, en general, las apuestas son m\xE1s altas. Para muchos tiradores, hacer un buen trabajo en un Gran Premio puede marcar la diferencia en la clasificaci\xF3n para un equipo nacional y formar parte de los Campeonatos del Mundo.</p>\n\n      <h2>MEDALLISTAS DE ORO</h2>\n      <p>Los medallistas de oro individuales y por equipo de los tres eventos incluyen lo siguiente:</p>\n\n      <h4>SABLE</h4>\n\n      <p><b>GP de sable de Se\xFAl<br>\n      (Se\xFAl, Corea)<br>\n      26-28 abril</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Sanguk Oh (KOR)</b></p>\n      <p>Mujeres - Individual:<br> <b>Olga Kharlan (UKR)</b></p>\n\n      <p><b>GP de sable de Mosc\xFA<br>\n      (Mosc\xFA, Rusia)<br>\n      24-26 May</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Bolade Apithy (FRA)</b></p>\n      <p>Mujeres - Individual:<br> <b>Sofya Velikaya (RUS)</b></p>\n\n\n      <h4>FLORETE</h4>\n\n      <p><b>GP de la FIE Absolute Fencing Gear<br>\n      (Anaheim, California EE. UU)<br>\n      15-17 marzo</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Julien Mertine (FRA)</b></p>\n      <p>Mujeres - Individual:<br> <b>Inna Deriglazova (RUS)</b></p>\n\n      <p><b>GP de florete de Shanghai<br>\n      (Shanghai, China)<br>\n      17-19 May</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Alessio Foconi (ITA)</b></p>\n      <p>Mujeres - Individual:<br> <b>Inna Deriglazova (RUS)</b></p>\n\n      <h4>ESPADA</h4>\n\n      <p><b>GP de Westend <br>\n      (Budapest, Hungr\xEDa)<br>\n      8-10 marzo</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Kazuyasu Minobe (JPN)</b></p>\n      <p>Mujeres - Individual:<br> <b>Ana Maria Popescu (ROU)</b></p>\n\n      <p><b>GP de espada de Cali<br>\n      (Cali, Colombia)<br>\n      3-5 May</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Kazuyasu Minobe (JPN)</b></p>\n      <p>Mujeres - Individual:<br> <b>Yiwen Sun (CHN)</b></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.openVideo('/111/en/static/_content/11-vid.m4v')\" style=\"bottom:460px;left:1146px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.allstar.de\" target=\"_blank\">\n        <img src=\"/111/es/static/_mobile/14.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:324px;right:1050px;width:264px; height:48px;\">\n          <a href=\"https://www.blaise-freres.fr\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/111/es/static/_mobile/15.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 16-title\" style=\"top:95px;left:82px\" src=\"/111/es/static/_content/16-title.png\">\n\n      <img class=\"halfScale 16-line\" style=\"top:275px;left:571px\" src=\"/111/es/static/_content/16-line.png\">\n\n      <img class=\"halfScale 16-sub\" style=\"top:275px;left:615px\" src=\"/111/es/static/_content/16-sub.png\">\n\n      <img class=\"halfScale pointer 16-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax()\n          pg16Anim.fromTo(cOf(\"16-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"16-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"16-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"16-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop()\n        }\n      ",
    "searchText": "C OPA DEL MUNDO  LOS TIRADORES TALENTOSOS SE ENFRENTAN AL MUNDO PRIMAVERA MARZO 1-MAYO 19",
    "mobileHtml": "\n      <h2>LOS TIRADORES TALENTOSOS SE ENFRENTAN AL MUNDO</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/16.jpg\">\n      <p><b>PRIMAVERA<br>\n      MARZO 1-MAYO 19</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 17-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax()\n          pg17Anim\n            .fromTo(cOf(\"17-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO PRIMAVERA 2019 2/3  Una espectacular presentación de la Copa del Mundo de alto nivel de esgrima tuvo lugar esta primavera en todo el mundo en las tres armas. De El Cairo a Chengdu, de San Petersburgo a Buenos Aires, y de Túnez a Sint-Niklaas, las Copas del Mundo de la FIE son la base de la competición mundial de esgrima de la que los tiradores de élite progresan a los Grandes Premios y a los Campeonatos del Mundo. Con la esgrima expandiéndose por todo el mundo, y a poco más de un año de los Juegos Olímpicos de Tokio 2020, están apareciendo muchas caras nuevas en el circuito senior de la Copa del Mundo de esgrima y están ansiosas",
    "mobileHtml": "\n      <p><b>Una espectacular presentaci\xF3n de la Copa del Mundo de alto nivel de esgrima tuvo lugar esta primavera en todo el mundo en las tres armas.</b></p>\n\n      <p>De El Cairo a Chengdu, de San Petersburgo a Buenos Aires, y de T\xFAnez a Sint-Niklaas, las Copas del Mundo de la FIE son la base de la competici\xF3n mundial de esgrima de la que los tiradores de \xE9lite progresan a los Grandes Premios y a los Campeonatos del Mundo.</p>\n\n      <p>Con la esgrima expandi\xE9ndose por todo el mundo, y a poco m\xE1s de un a\xF1o de los Juegos Ol\xEDmpicos de Tokio 2020, est\xE1n apareciendo muchas caras nuevas en el circuito senior de la Copa del Mundo de esgrima y est\xE1n ansiosas por ganar. Los atletas para los que esta es otra temporada de la Copa del Mundo se esfuerzan por mantener su posici\xF3n de puntos y expulsar a los reci\xE9n llegados mientras luchan una vez m\xE1s para llegar a la cima. Esta mezcla de talento y entusiasmo ha hecho que la temporada de tiradores sea excepcionalmente emocionante, ya que trabajan para clasificarse individualmente y por equipos para los pr\xF3ximos Campeonatos del Mundo de Budapest, as\xED como para Tokio 2020.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 18-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/10-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('18-pop')\" style=\"top:855px;left:59px\" src=\"/111/es/static/_content/trophy-red.png\">\n\n      <div id=\"18-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/18-pop.png\">\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse\" style=\"top:956px;left:946px\" src=\"/111/es/static/_content/trophy-white.png\">\n        </a>\n        <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('18-pop');\"></div>\n        <img id=\"18-sabre\" class=\"halfScale 18-events\" style=\"top:282px;left:269px;opacity:1\" src=\"/111/es/static/_content/18-sabre.png\">\n        <img id=\"18-foil\" class=\"halfScale 18-events\" style=\"top:383px;left:269px; opacity:0\" src=\"/111/es/static/_content/18-foil.png\">\n        <img id=\"18-epee\" class=\"halfScale 18-events\" style=\"top:336px;left:269px; opacity:0\" src=\"/111/es/static/_content/18-epee.png\">\n\n        <div class=\"contentLink\" style=\"top:336px;left:269px;height:225px;width:113px;\" onclick=\"toggleCategory('18-sabre', '18-events')\" src=\"/111/es/static/_content/18-sabre.png\"></div>\n        <div class=\"contentLink\" style=\"top:511px;left:269px;height:225px;width:113px;\" onclick=\"toggleCategory('18-foil', '18-events')\" src=\"/111/es/static/_content/18-foil.png\"></div>\n        <div class=\"contentLink\" style=\"top:741px;left:269px;height:225px;width:113px;\" onclick=\"toggleCategory('18-epee', '18-events')\" src=\"/111/es/static/_content/18-epee.png\"></div>\n\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax()\n          pg18Anim\n            .fromTo(cOf(\"18-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop()\n          hideOverlay('18-pop');\n        }\n      ",
    "searchText": "COPA DEL MUNDO PRIMAVERA 2019 3/3  Pulse aquí para ver los MEDALLISTAS DE ORO  por ganar. Los atletas para los que esta es otra temporada de la Copa del Mundo se esfuerzan por mantener su posición de puntos y expulsar a los recién llegados mientras luchan una vez más para llegar a la cima. Esta mezcla de talento y entusiasmo ha hecho que la temporada de tiradores sea excepcionalmente emocionante, ya que trabajan para clasificarse individualmente y por equipos para los próximos Campeonatos del Mundo de Budapest, así como para Tokio 2020.  Cada Copa del Mundo de la FIE incluye pruebas individuales y por equipos. En consecuencia, para muchos países estos eventos son esenciales para asegurar que sus equipos estén en las mejores condiciones posibles para los campeonatos zonales de verano y los Campeonatos del Mundo. A continuación se enumeran los aspectos más destacados de las personas y equipos ganadores en los eventos de la Copa del Mundo de la FIE desde febrero. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p>Cada Copa del Mundo de la FIE incluye pruebas individuales y por equipos. En consecuencia, para muchos pa\xEDses estos eventos son esenciales para asegurar que sus equipos est\xE9n en las mejores condiciones posibles para los campeonatos zonales de verano y los Campeonatos del Mundo.</p>\n      <p>A continuaci\xF3n se enumeran los aspectos m\xE1s destacados de las personas y equipos ganadores en los eventos de la Copa del Mundo de la FIE desde febrero.</p>\n\n      <h2>MEDALLISTAS DE ORO</h2>\n      <p>Los medallistas de oro individuales y por equipo de los tres eventos incluyen lo siguiente:</p>\n\n      <h4>SABLE</h4>\n\n      <p><b>8-10 marzo<br>\n      (Atenas, Grecia)<br>\n      \"Coupe Acropolis\"</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Mujeres - Individual:<br> <b>Sofia Pozdniakova (RUS)</b></p>\n      <p>Mujeres - Equipo:<br> <b>Francia</b></p>\n\n      <p><b>8-10 marzo<br>\n      (Padua, Italia)<br>\n      \"Trofea Luxardo\"</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Luca Curatoli (ITA)</b></p>\n      <p>Hombres - Equipo:<br> <b>Corea</b></p>\n\n      <p><b>22-24 marzo<br>\n      Sint-Niklaas, B\xE9lgica</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Mujeres - Individual:<br> <b>Manon Brunet (FRA)</b></p>\n      <p>Mujeres - Equipo:<br> <b>Francia</b></p>\n\n      <p><b>Budapest, Hungary</b><br>\n      <p>Hombres - Individual:<br> <b>Max Hartung (GER)</b></p>\n      <p>Hombres - Equipo:<br> <b>Corea</b></p>\n\n      <p><b>5-12 mayo<br>\n      T\xFAnez, T\xFAnez</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Mujeres - Individual:<br> <b>Sofya Velikaya (RUS)</b></p>\n      <p>Mujeres - Equipo:<br> <b>Italia</b></p>\n\n      <p><b>Madrid, Espa\xF1a</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Max Hartung (GER)</b></p>\n      <p>Hombres - Equipo:<br> <b>Italia</b></p>\n\n\n      <h4>FLORETE</h4>\n      <p><b>1-3 marzo<br>\n      El Cairo, Egipto</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Daniele Garozzo (ITA)</b></p>\n      <p>Hombres - Equipo:<br> <b>EE. UU.</b></p>\n\n      <p>Mujeres - Individual:<br> <b>Inna Deriglazova (RUS)</b></p>\n      <p>Mujeres - Equipo:<br> <b>Italia</b></p>\n\n      <p><b>3-5 mayo<br>\n      Tauberbischofsheim, Alemania</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Mujeres - Individual:<br> <b>Inna Deriglazova (RUS)</b></p>\n      <p>Mujeres - Equipo:<br> <b>EE. UU.</b></p>\n\n      <p><b>3-5 mayo<br>\n      San Petersburgo, Rusia</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Andrea Cassard (ITA)</b></p>\n      <p>Hombres - Equipo:<br> <b>USA</b></p>\n\n      <h4>ESPADA</h4>\n\n      <p><b>22-24 marzo<br>\n      Buenos Aires, Argentina</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Sergey Bida (RUS)</b></p>\n      <p>Hombres - Equipo:<br> <b>Jap\xF3n</b></p>\n\n      <p><b>22-24 marzo<br>\n      Chengdu, China</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Mujeres - Individual:<br> <b>Helene Ngom (FRA)</b></p>\n      <p>Mujeres - Equipo:<br> <b>Alemania</b></p>\n\n      <p><b>17-19 May<br>\n      Dubai, Emiratos \xC1rabes Unidos</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Mujeres - Individual:<br> <b>Injeong Choi (KOR)</b></p>\n      <p>Mujeres - Equipo:<br> <b>Polonia</b></p>\n\n      <p><b>17-19 May<br>\n      \"Challenge SNCF Reseau\" Par\xEDs, Francia</b></p>\n      <p>Fecha - G\xE9nero\tEvento - <b>Medallistas</b></p>\n      <p>Hombres - Individual:<br> <b>Sangyoung Park (KOR)</b></p>\n      <p>Team - Men's:<br> <b>Suiza</b></p>\n\n      <p><a href=\"https://fie.org/competitions\" target=\"_blank\">Tap here to see the full results</a></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 19-title\" style=\"top:108px;left:82px\" src=\"/111/es/static/_content/19-title.png\">\n\n      <img class=\"halfScale 19-line\" style=\"top:372px;left:87px\" src=\"/111/es/static/_content/19-line.png\">\n\n      <img class=\"halfScale 19-sub\" style=\"top:363px;left:130px\" src=\"/111/es/static/_content/19-sub.png\">\n\n      <img class=\"halfScale pointer 19-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax()\n          pg19Anim.fromTo(cOf(\"19-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"19-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"19-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"19-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS ZONALES DE ESGRIMA  CAMPEONATOS ZONALES DE ESGRIMA 2019, ¡ROCK THE CONTINENTS! ALEMANIA, CANADÁ, MALI, JAPÓN JUNIO 13-JULIO 2",
    "mobileHtml": "\n      <h2>CAMPEONATOS ZONALES DE ESGRIMA 2019, \xC1ROCK THE CONTINENTS!</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/19.jpg\">\n      <p><b>ALEMANIA, CANAD\xC1<br>\n      MALI, JAP\xD3N<br>\n      JUNIO 13-JULIO 2</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 20-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax()\n          pg20Anim\n            .fromTo(cOf(\"20-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS ZONALES DE ESGRIMA JUNIO 13-JULIO 2 2/5  Cada año, los campeonatos de esgrima de la FIE para cada región zonal tienen lugar en Europa, América, África, Asia y Oceanía. Esto permite a un gran número de tiradores de cada zona participar en el principal evento de esgrima en pruebas individuales y por equipos. Mientras que para algunos tiradores esta es una oportunidad nueva o incluso la primera vez que pueden participar en un gran evento internacional/continental, para otros que ya son competidores mundiales experimentados, es otro escalón en el proceso de clasificación para los Campeonatos del Mundo (en este",
    "mobileHtml": "\n      <p><b>Cada a\xF1o, los campeonatos de esgrima de la FIE para cada regi\xF3n zonal tienen lugar en Europa, Am\xE9rica, \xC1frica, Asia y Ocean\xEDa.</b></p>\n\n      <p>Esto permite a un gran n\xFAmero de tiradores de cada zona participar en el principal evento de esgrima en pruebas individuales y por equipos. Mientras que para algunos tiradores esta es una oportunidad nueva o incluso la primera vez que pueden participar en un gran evento internacional/continental, para otros que ya son competidores mundiales experimentados, es otro escal\xF3n en el proceso de clasificaci\xF3n para los Campeonatos del Mundo (en este caso, los pr\xF3ximos Campeonatos del Mundo de Esgrima, que tendr\xE1n lugar en Budapest en julio del 2019) y, en \xFAltima instancia, para los Juegos Ol\xEDmpicos de Tokio 2020.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 21-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax()\n          pg21Anim\n            .fromTo(cOf(\"21-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS ZONALES DE ESGRIMA JUNIO 13-JULIO 2 3/5  caso, los próximos Campeonatos del Mundo de Esgrima, que tendrán lugar en Budapest en julio del 2019) y, en última instancia, para los Juegos Olímpicos de Tokio 2020. Este año, los campeonatos zonales de junio y julio se celebraron en Dusseldorf, Alemania (Europa); Toronto, Canadá (Panamericana); Bamako, Mali (África); y Tokio, Japón (Asia/Oceanía), con un total de 48 medallas de oro en todo el mundo para hombres y mujeres en pruebas individuales y por equipos en tres armas. ■",
    "mobileHtml": "\n      <p>Este a\xF1o, los campeonatos zonales de junio y julio se celebraron en Dusseldorf, Alemania (Europa); Toronto, Canad\xE1 (Panamericana); Bamako, Mali (\xC1frica); y Tokio, Jap\xF3n (Asia/Ocean\xEDa), con un total de 48 medallas de oro en todo el mundo para hombres y mujeres en pruebas individuales y por equipos en tres armas.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 22-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax()\n          pg22Anim\n            .fromTo(cOf(\"22-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS ZONALES DE ESGRIMA JUNIO 13-JULIO 2 4/5  FIE 2019 CAMPEONATOS ZONALES Europa/Dusseldorf, Alemania del 17 al 22 de junio Sable Mujeres Individual Olga Kharlan (UKR) Hombres Individual Veniamin 			 Reshetnikov (RUS) Mujeres Equipos Rusia Hombres Equipos Alemania Florete Hombres Individual Mujeres Individual Hombres Equipos Mujeres Equipos  Alessio Foconi (ITA) Elisa Di Francisca (ITA) Francia Rusia  Espada Hombres Individual 			 Mujeres Individual Hombres Equipos Mujeres Equipos  Yuval Shalom Freilich (ISR) Coraline Vitalis (FRA) Rusia Polonia  Asia/Oceanía-Tokio, Japón - del 13 al 18 de junio Sable Mujeres Individual Jisu Yoon (KOR) Hombres Individual Sanguk Oh (KOR)  Mujeres Equipos Hombres Equipos  China Corea  Florete Hombres Individual Mujeres Individual Hombres Equipos Mujeres Equipos  Takahiro Shikine (JPN) Hee Sook Jeon (KOR) Japón Japón  Espada Mujeres Individual Hombres Individual Mujeres Equipos Hombres Equipos  Mingye Zhu (CHN) Masaru Yamada (JPN) Corea China  África/Bamako, Malí - del 24 al 28 de junio Sable Mujeres Individual Amira 			 Ben Chaabane (TUN) Hombres Individual Mohamed Amer (EGY) Mujeres Equipos Túnez Hombres Equipos Egipto",
    "mobileHtml": "\n      <h2>FIE 2019 campeonatos zonales</h2>\n\n      <h4>Europa/Dusseldorf, Alemania<br>\n      17-22 June</h4>\n\n      <h4>Sable</h4>\n      <p>Mujeres - Individual:<br> <b>Olga Kharlan (UKR)</b></p>\n      <p>Hombres - Individual:<br> <b>Veniamin Reshetnikov (RUS)</b></p>\n      <p>Mujeres - Equipos:<br> <b>Rusia</b></p>\n      <p>Hombres - Equipos:<br> <b>Alemania</b></p>\n      <h4>Florete</h4>\n      <p>Hombres - Individual:<br> <b>Alessio Foconi (ITA)</b></p>\n      <p>Mujeres - Individual:<br> <b>Elisa Di Francisca (ITA)</b></p>\n      <p>Hombres - Equipos:<br> <b>Francia</b></p>\n      <p>Mujeres - Equipos:<br> <b>Rusia</b></p>\n      <h4>Espada</h4>\n      <p>Hombres - Individual:<br> <b>Yuval Shalom Freilich (ISR)</b></p>\n      <p>Mujeres - Individual:<br> <b>Coraline Vitalis (FRA)</b></p>\n      <p>Hombres - Equipos:<br> <b>Rusia</b></p>\n      <p>Mujeres - Equipos:<br> <b>Polonia</b></p>\n\n      <h4>Asia/Ocean\xEDa-Tokio, Jap\xF3n-del<br>\n      13 al 18 de junio</h4>\n      <h4>Sable</h4>\n      <p>Mujeres - Individual:<br> <b>Jisu Yoon (KOR)</b></p>\n      <p>Hombres - Individual:<br> <b>Sanguk Oh (KOR)</b></p>\n      <p>Mujeres - Equipos:<br> <b>China</b></p>\n      <p>Hombres - Equipos:<br> <b>Corea</b></p>\n      <h4>Florete</h4>\n      <p>Hombres - Individual:<br> <b>Takahiro Shikine (JPN)</b></p>\n      <p>Mujeres - Individual:<br> <b>Hee Sook Jeon (KOR)</b></p>\n      <p>Hombres - Equipos:<br> <b>Jap\xF3n</b></p>\n      <p>Mujeres - Equipos:<br> <b>Jap\xF3n</b></p>\n      <h4>Espada</h4>\n      <p>Hombres - Individual:<br> <b>Mingye Zhu (CHN)</b></p>\n      <p>Mujeres - Individual:<br> <b>Masaru Yamada (JPN)</b></p>\n      <p>Hombres - Equipos:<br> <b>Corea</b></p>\n      <p>Mujeres - Equipos:<br> <b>China</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 23-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/10-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax()\n          pg23Anim\n            .fromTo(cOf(\"23-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS ZONALES DE ESGRIMA JUNIO 13-JULIO 2 5/5  Florete Hombres Individual 			 Mujeres Individual Hombres Equipos Mujeres Equipos  Alaaeldin Abouelkassem (EGY) Ines Boubakri (TUN) Egipto Túnez  Espada Mujeres Individual Hombres Individual Mujeres Equipos Hombres Equipos  Sarra Besbes (TUN) Houssam Elkord (MAR) Egipto Marruecos  Panamerica/Toronto, Canadá del 27 de junio al 2 de julio Sable Hombres Individual Eli Dershwitz (EE. UU.) Mujeres Individual Anne			 Elizabeth Stone (EE. UU.) Hombres Equipos EE. UU. Mujeres Equipos EE. UU. Florete Mujeres Individual Hombres Individual Mujeres Equipos Hombres Equipos  Nicole Ross (EE. UU.) Race Imboden (EE. UU.) EE. UU. EE. UU.  Espada Mujeres Individual Hombres Individual 			 Mujeres Equipos Hombres Equipos  Kelley Hurley (EE. UU.) Ruben Limardo Gascon (VEN) EE. UU. Cuba  W W W.FIE .ORG",
    "mobileHtml": "\n      <h4>\xC1frica/Bamako, Mal\xED<br>del - 24 al 28 de junio</h4>\n      <h4>Sable</h4>\n      <p>Mujeres - Individual:<br> <b>Amira Ben Chaabane (TUN)</b></p>\n      <p>Hombres - Individual:<br> <b>Mohamed Amer (EGY)</b></p>\n      <p>Mujeres - Equipos:<br> <b>T\xFAnez</b></p>\n      <p>Hombres - Equipos:<br> <b>Egipto</b></p>\n      <h4>Florete</h4>\n      <p>Hombres - Individual:<br> <b>Alaaeldin Abouelkassem (EGY)</b></p>\n      <p>Mujeres - Individual:<br> <b>Ines Boubakri (TUN)</b></p>\n      <p>Hombres - Equipos:<br> <b>Egipto</b></p>\n      <p>Mujeres - Equipos:<br> <b>Tunisia</b></p>\n      <h4>Espada</h4>\n      <p>Mujeres - Individual:<br> <b>Sarra Besbes (TUN)</b></p>\n      <p>Hombres - Individual:<br> <b>Houssam Elkord (MAR)</b></p>\n      <p>Mujeres - Equipos:<br> <b>Egipto</b></p>\n      <p>Hombres - Equipos:<br> <b>Marruecos</b></p>\n\n      <h4>Panamerica/Toronto, Canad\xE1<br>\n      del 27 de junio al 2 de julio</h4>\n      <h4>Sable</h4>\n      <p>Mujeres - Individual:<br> <b>Anne-Elizabeth Stone (EE. UU.)</b></p>\n      <p>Hombres - Individual:<br> <b>Eli Dershwitz (EE. UU.)</b></p>\n      <p>Mujeres - Equipos:<br> <b>EE. UU.</b></p>\n      <p>Hombres - Equipos:<br> <b>EE. UU.</b></p>\n      <h4>Florete</h4>\n      <p>Hombres - Individual:<br> <b>Race Imboden (EE. UU.)</b></p>\n      <p>Mujeres - Individual:<br> <b>Nicole Ross (EE. UU.)</b></p>\n      <p>Hombres - Equipos:<br> <b>EE. UU.</b></p>\n      <p>Mujeres - Equipos:<br> <b>EE. UU.</b></p>\n      <h4>Espada</h4>\n      <p>Mujeres - Individual:<br> <b>Kelley Hurley (EE. UU.)</b></p>\n      <p>Hombres - Individual:<br> <b>Ruben Limardo Gascon (VEN)</b></p>\n      <p>Mujeres - Equipos:<br> <b>EE. UU.</b></p>\n      <p>Hombres - Equipos:<br> <b>Cuba</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:71px;right:320px;width:830px; height:48px;\">\n          <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.blue-gauntlet.com\" target=\"_blank\">\n        <img src=\"/111/es/static/_mobile/24.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:326px;right:361px;width:169px; height:48px;\">\n          <a href=\"http://www.favero.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.favero.com\" target=\"_blank\">\n        <img src=\"/111/es/static/_mobile/25.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 26-title\" style=\"top:98px;left:79px\" src=\"/111/es/static/_content/26-title.png\">\n\n      <img class=\"halfScale 26-line\" style=\"top:346px;left:85px\" src=\"/111/es/static/_content/26-line.png\">\n\n      <img class=\"halfScale 26-sub\" style=\"top:338px;left:126px\" src=\"/111/es/static/_content/26-sub.png\">\n\n      <img class=\"halfScale pointer 26-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax()\n          pg26Anim.fromTo(cOf(\"26-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"26-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"26-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"26-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop()\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO  CAMPEONATO DEL MUNDO DE ESGRIMA DE 2019 EN BUDAPEST BUDAPEST, HUNGRÍA JULIO 2019",
    "mobileHtml": "\n      <h2>CAMPEONATO DEL MUNDO DE ESGRIMA DE 2019 EN BUDAPEST</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/26.jpg\">\n      <p><b>BUDAPEST, HUNGR\xCDA<br>\n      JULIO 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 27-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/8-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax()\n          pg27Anim\n            .fromTo(cOf(\"27-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop()\n        }\n      ",
    "searchText": "Durante las ceremonias de apertura del 18 de julio, el primer día de las finales, Thomas Bach, presidente del Comité Olímpico Internacional y campeón olímpico de esgrima, Alisher Usmanov, Presidente de la FIE, y Tunde Szabo, secretario de estado húngaro de Deporte del Ministerio de Recursos Humanos, dieron cada uno un discurso de bienvenida a la audiencia internacional y el Campeonato del Mundo fue inaugurado oficialmente por el Sr. Bach.  CAMPEONATOS DEL MUNDO BUDAPEST, HUNGRÍA 2/3  El último gran campeonato del mundo senior antes de los Juegos Olímpicos de Tokio 2020: 118 países participaron en el Campeonato del Mundo de Esgrima de 2019 en Budapest, que englobaron 12 pruebas individuales y por equipos durante nueve días en julio. La competición se celebró en el BOK Sports Hall (también conocido como el Centro de deportes y congresos SYMA), una de las instalaciones deportivas y de reuniones más importantes de Hungría. El Campeonato del Mundo se habían celebrado allí anteriormente en 2013.  En la tarde en que se celebraron las pruebas de sable masculino y espada femenina por equipos, Janos Ader, presidente de la República de Hungría, asistió y presenció las finales y entregó las medallas al equipo húngaro, que obtuvo la medalla de plata en sable masculino, ante un público muy numeroso y animado. El Campeonato comenzó con tres días de competición individual preliminar, seguidos de tres días de pruebas individuales eliminatorias con los primeros 64 clasificados de espada, florete y sable, con dos finales por la medalla de oro cada noche (una masculina y una femenina). En los últimos tres días de Campeonato, se celebró la competición por equipos, de nuevo en las tres armas para hombres y mujeres, con dos finales cada día. Una multitud",
    "mobileHtml": "\n      <p><b>El \xFAltimo gran campeonato del mundo senior antes de los Juegos Ol\xEDmpicos de Tokio 2020: 118 pa\xEDses participaron en el Campeonato del Mundo de Esgrima de 2019 en Budapest, que englobaron 12 pruebas individuales y por equipos durante nueve d\xEDas en julio.</b></p>\n\n      <p>La competici\xF3n se celebr\xF3 en el BOK Sports Hall (tambi\xE9n conocido como el Centro de deportes y congresos SYMA), una de las instalaciones deportivas y de reuniones m\xE1s importantes de Hungr\xEDa. El Campeonato del Mundo se hab\xEDan celebrado all\xED anteriormente en 2013.</p>\n\n      <p>Durante las ceremonias de apertura del 18 de julio, el primer d\xEDa de las finales, Thomas Bach, presidente del Comit\xE9 Ol\xEDmpico Internacional y campe\xF3n ol\xEDmpico de esgrima, Alisher Usmanov, Presidente de la FIE, y Tunde Szabo, secretario de estado h\xFAngaro de Deporte del Ministerio de Recursos Humanos, dieron cada uno un discurso de bienvenida a la audiencia internacional y el Campeonato del Mundo fue inaugurado oficialmente por el Sr. Bach.</p>\n\n      <p>En la tarde en que se celebraron las pruebas de sable masculino y espada femenina por equipos, Janos Ader, presidente de la Rep\xFAblica de Hungr\xEDa, asisti\xF3 y presenci\xF3 las finales y entreg\xF3 las medallas al equipo h\xFAngaro, que obtuvo la medalla de plata en sable masculino, ante un p\xFAblico muy numeroso y animado.</p>\n\n      <p>El Campeonato comenz\xF3 con tres d\xEDas de competici\xF3n individual preliminar, seguidos de tres d\xEDas de pruebas individuales eliminatorias con los primeros 64 clasificados de espada, florete y sable, con dos finales por la medalla de oro cada noche (una masculina y una femenina). En los \xFAltimos tres d\xEDas de Campeonato, se celebr\xF3 la competici\xF3n por equipos, de nuevo en las tres armas para hombres y mujeres, con dos finales cada d\xEDa. Una multitud en\xE9rgica y muy animada disfrut\xF3 diariamente de un grand\xEDsimo espect\xE1culo de luces en la arena de las finales durante las pruebas, junto con juegos interactivos de preguntas y respuestas y artistas en el escenario.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 28-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/10-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-red.png\">\n      </a>\n\n      <a href=\"https://www.facebook.com/fie.org/videos/1172465969621374/\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"top:624px;left:49px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#F11E22\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n      </a>\n\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('28-pop')\" style=\"top:855px;left:59px\" src=\"/111/es/static/_content/trophy-red.png\">\n\n      <div id=\"28-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/28-pop.png\">\n        <a href=\"https://fie.org/competitions/2019/250\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse\" style=\"top:916px;left:941px\" src=\"/111/es/static/_content/trophy-white.png\">\n        </a>\n        <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('28-pop');\"></div>\n        <img id=\"28-sabre\" class=\"halfScale 28-events\" style=\"top:335px;left:269px;opacity:1\" src=\"/111/es/static/_content/28-sabre.png\">\n        <img id=\"28-foil\" class=\"halfScale 28-events\" style=\"top:406px;left:269px; opacity:0\" src=\"/111/es/static/_content/28-foil.png\">\n        <img id=\"28-epee\" class=\"halfScale 28-events\" style=\"top:409px;left:269px; opacity:0\" src=\"/111/es/static/_content/28-epee.png\">\n\n        <div class=\"contentLink\" style=\"top:336px;left:269px;height:190px;width:113px;\" onclick=\"toggleCategory('28-sabre', '28-events')\" src=\"/111/es/static/_content/28-sabre.png\"></div>\n        <div class=\"contentLink\" style=\"top:529px;left:269px;height:190px;width:113px;\" onclick=\"toggleCategory('28-foil', '28-events')\" src=\"/111/es/static/_content/28-foil.png\"></div>\n        <div class=\"contentLink\" style=\"top:723px;left:269px;height:190px;width:113px;\" onclick=\"toggleCategory('28-epee', '28-events')\" src=\"/111/es/static/_content/28-epee.png\"></div>\n\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax()\n          pg28Anim\n            .fromTo(cOf(\"28-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          hideOverlay('28-pop')\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO BUDAPEST, HUNGRÍA 3/3  enérgica y muy animada disfrutó diariamente de un grandísimo espectáculo de luces en la arena de las finales durante las pruebas, junto con juegos interactivos de preguntas y respuestas y artistas en el escenario. El recuento de medallas fue diverso y gran número de países consiguió subir al podio. En particular, para tres países, Brasil, Grecia y Hong Kong, fue la primera vez en la historia en la que han conseguido una medalla en el Campeonato del Mundo de Esgrima senior. Antes del comienzo del Campeonato del Mundo de Esgrima de Budapest de 2019 este mes, se realizó un taller 365 sobre la profesión y la divulgación de la Comisión de Atletas del COI para 20 tiradores en un curso de entrenamiento oficial de la FIE. La dos veces olímpica Maria Ntanou (GRE) dirigió el programa. El taller  Pulse aquí para ver los MEDALLISTAS DE ORO  de un día cubrió módulos como aprender a gestionar una carrera doble y trabajar en ella por adelantado, competencias en materia de creación de redes para el desarrollo de carreras profesionales, atributos conductuales del desarrollo profesional, creación de un plan profesional y cómo usar las redes sociales como parte del desarrollo profesional de los atletas. Budapest ofrece numerosas atracciones interesantes y emocionantes para los tiradores y los demás visitantes, con una región declarada Patrimonio de la Humanidad por la UNESCO, así como numerosas opciones culturales, de entretenimiento, cocina, arte e historia. Para clausurar oficialmente el Campeonato del Mundo el 23 de julio, Emmanuel Katsiadakis, secretario general de la FIE, dirigió el paso de la bandera de la FIE de Hungría, como país anfitrión, a Japón, para los Juegos Olímpicos de Tokio 2020 del próximo año. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p>El recuento de medallas fue diverso y gran n\xFAmero de pa\xEDses consigui\xF3 subir al podio. En particular, para tres pa\xEDses, Brasil, Grecia y Hong Kong, fue la primera vez en la historia en la que han conseguido una medalla en el Campeonato del Mundo de Esgrima senior.</p>\n\n      <p>Antes del comienzo del Campeonato del Mundo de Esgrima de Budapest de 2019 este mes, se realiz\xF3 un taller 365 sobre la profesi\xF3n y la divulgaci\xF3n de la Comisi\xF3n de Atletas del COI para 20 tiradores en un curso de entrenamiento oficial de la FIE. La dos veces ol\xEDmpica Maria Ntanou (GRE) dirigi\xF3 el programa. El taller de un d\xEDa cubri\xF3 m\xF3dulos como aprender a gestionar una carrera doble y trabajar en ella por adelantado, competencias en materia de creaci\xF3n de redes para el desarrollo de carreras profesionales, atributos conductuales del desarrollo profesional, creaci\xF3n de un plan profesional y c\xF3mo usar las redes sociales como parte del desarrollo profesional de los atletas.</p>\n\n      <p>Budapest ofrece numerosas atracciones interesantes y emocionantes para los tiradores y los dem\xE1s visitantes, con una regi\xF3n declarada Patrimonio de la Humanidad por la UNESCO, as\xED como numerosas opciones culturales, de entretenimiento, cocina, arte e historia.</p>\n\n      <p>Para clausurar oficialmente el Campeonato del Mundo el 23 de julio, Emmanuel Katsiadakis, secretario general de la FIE, dirigi\xF3 el paso de la bandera de la FIE de Hungr\xEDa, como pa\xEDs anfitri\xF3n, a Jap\xF3n, para los Juegos Ol\xEDmpicos de Tokio 2020 del pr\xF3ximo a\xF1o.</p>\n\n      <h2>MEDALLISTAS DE ORO</h2>\n      <p>Los medallistas de oro individuales y por equipo de los tres eventos incluyen lo siguiente:</p>\n\n      <h4>SABLE</h4>\n      <p>Fecha - G\xE9nero\tPrueba - <b>Medallistas</b></p>\n      <p>18 Julio - Hombres - Individual:<br> <b>Sanguk Oh (KOR)</b></p>\n      <p>20 Julio - Mujeres - Individual:<br> <b>Olga Kharlan (UKR)</b></p>\n      <p>21 Julio - Hombres - Por equipos:<br> <b>Corea</b></p>\n      <p>23 Julio - Mujeres - Por equipos:<br> <b>Rusia</b></p>\n\n      <h4>FLORETE</h4>\n      <p>Fecha - G\xE9nero\tPrueba - <b>Medallistas</b></p>\n      <p>19 Julio - Mujeres - Individual:<br> <b>Inna Deriglazova (RUS)</b></p>\n      <p>20 Julio - Hombres - Individual:<br> <b>Enzo Lefort (FRA)</b></p>\n      <p>22 Julio - Hombres - Por equipos:<br> <b>Rusia</b></p>\n      <p>23 Julio - Mujeres - Por equipos:<br> <b>EE. UU.</b></p>\n\n      <h4>ESPADA</h4>\n      <p>Fecha - G\xE9nero\tPrueba - <b>Medallistas</b></p>\n      <p>18 Julio - Mujeres - Individual:<br> <b>Nathalie Moellhausen (BRA)</b></p>\n      <p>19 Julio - Hombres - Individual:<br> <b>Gergely Siklosi (HUN)</b></p>\n      <p>21 Julio - Mujeres - Por equipos:<br> <b>China</b></p>\n      <p>22 Julio - Hombres - Por equipo:<br> <b>Francia</b></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:124px;right:459px;width:310px; height:25px;\">\n          <a href=\"http://www.jiangfencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:98px;right:459px;width:310px; height:25px;\">\n          <a href=\"mailto:jason@jiangfencing.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <img src=\"/111/es/static/_mobile/29.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 30-title\" style=\"top:20px;left:71px\" src=\"/111/es/static/_content/30-no.png\">\n\n      <img class=\"halfScale 30-name-1\" style=\"top:647px;left:-353px\" src=\"/111/es/static/_content/30-title-1.png\">\n      <img class=\"halfScale 30-name-2\" style=\"top:773px;left:168px\" src=\"/111/es/static/_content/30-title-2.png\">\n\n      <img class=\"halfScale pointer 30-arrow\" style=\"top:949px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/30-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax()\n          pg30Anim\n            .fromTo(cOf(\"30-title\"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)\n            .fromTo(cOf(\"30-name-1\"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(cOf(\"30-name-2\"), 0.4,{x:200,opacity:0}, {x:0,opacity:1},\"-=0.1\")\n            .fromTo(cOf(\"30-arrow\"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, \"-=0.1\")\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop()\n        }\n      ",
    "searchText": "C ONOZCA A LOS ATLE TAS  			 ELI DERSHWITZ",
    "mobileHtml": "\n      <h2>ELI DERSHWITZ</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/30.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <img id=\"31-next\" class=\"halfScale pointer\" style=\"top:949px;left:648px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/30-arrow.jpg\">\n\n      <img id=\"31-img-1\" class=\"halfScale 31-questions\" style=\"top:21px;left:20px\" src=\"/111/es/static/_content/31-img-1.jpg\">\n      <img id=\"31-img-2\" class=\"halfScale 31-questions\" style=\"top:22px;left:22px; display: none;\" src=\"/111/es/static/_content/31-img-2.jpg\">\n      <img id=\"31-img-3\" class=\"halfScale 31-questions\" style=\"top:22px;left:22px; display: none;\" src=\"/111/es/static/_content/31-img-3.jpg\">\n      <img id=\"31-img-4\" class=\"halfScale 31-questions\" style=\"top:22px;left:22px; display: none;\" src=\"/111/es/static/_content/31-img-4.jpg\">\n      <img id=\"31-img-5\" class=\"halfScale 31-questions\" style=\"top:22px;left:22px; display: none;\" src=\"/111/es/static/_content/31-img-5.jpg\">\n      <img id=\"31-img-6\" class=\"halfScale 31-questions\" style=\"top:22px;left:22px; display: none;\" src=\"/111/es/static/_content/31-img-6.jpg\">\n      <img id=\"31-img-7\" class=\"halfScale 31-questions\" style=\"top:22px;left:22px; display: none;\" src=\"/111/es/static/_content/31-img-7.jpg\">\n\n      <img id=\"31-no-1\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px\" src=\"/111/es/static/_content/31-1.png\">\n      <img id=\"31-no-2\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/111/es/static/_content/31-2.png\">\n      <img id=\"31-no-3\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/111/es/static/_content/31-3.png\">\n      <img id=\"31-no-4\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/111/es/static/_content/31-4.png\">\n      <img id=\"31-no-5\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/111/es/static/_content/31-5.png\">\n      <img id=\"31-no-6\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/111/es/static/_content/31-6.png\">\n      <img id=\"31-no-7\" class=\"halfScale 31-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/111/es/static/_content/31-7.png\">\n\n      <div class=\"addContentLink\" style=\"top: 443px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-1', '31-img-1')\"></div>\n      <div class=\"addContentLink\" style=\"top: 538px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-2', '31-img-2')\"></div>\n      <div class=\"addContentLink\" style=\"top: 629px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-3', '31-img-3')\"></div>\n      <div class=\"addContentLink\" style=\"top: 722px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-4', '31-img-4')\"></div>\n      <div class=\"addContentLink\" style=\"top: 813px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-5', '31-img-5')\"></div>\n      <div class=\"addContentLink\" style=\"top: 907px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-6', '31-img-6')\"></div>\n      <div class=\"addContentLink\" style=\"top: 1000px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('31-no-7', '31-img-7')\"></div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg31Anim = new TimelineMax()\n        pg31Anim.fromTo(idOf(\"31-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)\n      }\n\n      function swapQuestion(ele, img) {\n        var x = cOf(\"31-questions\");\n        var i;\n        for (i = 0; i < x.length; i++) {\n          x[i].style.display = 'none';\n        }\n        idOf(ele).style.display = \"\"\n        idOf(img).style.display = \"\"\n      }\n\n      function onPageLeave() {\n        pg31Anim.stop()\n        removeContentLinks()\n      }\n      ",
    "searchText": "El esgrimista de sable estadounidense Eli Dershwitz es el esgrimista de sable masculino número uno en el mundo. También es estudiante de la Universidad de Harvard, lo que hace difícil imaginar una vida más activa para un atleta de 23 años. Eli comparte con nosotros algunos información sobre su origen y sobre cómo gestiona su vida:  ¿Cómo te convertiste en esgrimista? ¿Cuántos años tenías? Empecé a practicar esgrima cuando tenía nueve años, porque mi hermano Phil practicaba. Fui al club con mi madre a recogerlo y me encantaba ver las clases, y a veces el entrenador me dejaba correr en el suelo del club. Una vez que empecé a practicar esgrima, mi hermano y yo practicábamos juntos y él me impulsó a ser mejor, así que le debo mucho de mi éxito a él.  1 2 3 4 5 6 7",
    "mobileHtml": "\n      <p><b>El esgrimista de sable estadounidense Eli Dershwitz es el esgrimista de sable masculino n\xFAmero uno en el mundo. Tambi\xE9n es estudiante de la Universidad de Harvard, lo que hace dif\xEDcil imaginar una vida m\xE1s activa para un atleta de 23 a\xF1os. Eli comparte con nosotros algunos informaci\xF3n sobre su origen y sobre c\xF3mo gestiona su vida:</b></p>\n      <br>\n\n      <p><b>1 \xBFC\xF3mo te convertiste en esgrimista? \xBFCu\xE1ntos a\xF1os ten\xEDas?</b></p>\n      <p>Empec\xE9 a practicar esgrima cuando ten\xEDa nueve a\xF1os, porque mi hermano Phil practicaba. Fui al club con mi madre a recogerlo y me encantaba ver las clases, y a veces el entrenador me dejaba correr en el suelo del club. Una vez que empec\xE9 a practicar esgrima, mi hermano y yo practic\xE1bamos juntos y \xE9l me impuls\xF3 a ser mejor, as\xED que le debo mucho de mi \xE9xito a \xE9l.</p>\n\n      <p><b>2 \xBFQu\xE9 o qui\xE9n ha representado la mayor influencia en su vida como esgrimista? \xBFPor qu\xE9?</b></p>\n      <p>Mi familia y mi entrenador. No importa lo que pase, mis padres, mi hermano Phil y mi hermana Sally han estado ah\xED para m\xED. Mi entrenador, Z, nunca me ha dejado conformarme con nada menos que lo mejor de m\xED mismo, tanto dentro como fuera de la pista. Nada estaba fuera de mi alcance, desde la esgrima hasta lo acad\xE9mico, si trabajaba lo suficiente.</p>\n\n      <p><b>3 Cu\xE9ntanos algunas de tus mejores experiencias con el esgrima.</b></p>\n      <p>Tres, en concreto: Ganar la medalla de oro en sable masculino j\xFAnior en los Campeonatos Mundiales Juveniles y Cadete de 2015 en Tashkent. Hab\xEDa so\xF1ado y trabajado para convertirme en el primer esgrimista de sable estadounidense en ganar un t\xEDtulo mundial. Ganar la medalla de oro en el Gran Premio de Se\xFAl de 2016 solidific\xF3 mi puesto en el equipo ol\xEDmpico de 2016, y fue uno de los mejores y m\xE1s emotivos d\xEDas de mi vida. Tambi\xE9n ganar el Mundial de Varsovia en 2019, porque era el pa\xEDs de muchos de mis abuelos y algo que yo hab\xEDa querido conseguir.</p>\n\n      <p><b>4 \xBFCu\xE1les crees que son tus mayores logros como esgrimista? \xBFPor qu\xE9?</b></p>\n      <p>Ganar la copa del mundo en la temporada 2017-2018 y terminar la temporada de 2018 en el primer puesto del ranking mundial.</p>\n\n      <p><b>5 Actualmente sigues siendo el n\xFAmero uno del mundo en sable masculino. Dices quiz\xE1s tu mayor ambici\xF3n es estar en los Juegos Ol\xEDmpicos de Tokio 2020. \xBFQu\xE9 debe pasar para que lo consigas?</b></p>\n      <p>Formar parte del equipo de Tokio 2020 y volver a casa con una medalla son dos grandes ambiciones. Siento que ahora estoy en mejor posici\xF3n que en R\xEDo 2016, y creo que si trabajo lo suficiente, puedo esforzarme para ganar una medalla (o dos) en Tokio.</p>\n\n      <p><b>6 Aparte del esgrima como atleta, \xBFqu\xE9 has hecho con el esgrima (por ejemplo, caridad, ense\xF1anza, programas especiales, etc.)?</b></p>\n      <p>Devolver lo aprendido trabajando con clases de principiantes y ense\xF1ando a los ni\xF1os en los campamentos de verano. Creo que no ser\xEDa la persona que soy hoy sin la esgrima, as\xED que, cuando tengo una oportunidad, me gusta ayudar mostrando y ense\xF1ando a los j\xF3venes esgrimistas por qu\xE9 este deporte es tan incre\xEDble.</p>\n\n      <p><b>7 \xBFCu\xE1l es tu mensaje para los j\xF3venes esgrimistas?</b></p>\n      <p>Disfrutad de cada momento del esgrima tanto como pod\xE1is. A medida que avanz\xE1is, el esgrima puede volverse m\xE1s duro o m\xE1s serio, y como ni\xF1os en el deporte, lo m\xE1s importante es que os asegur\xE9is de que os est\xE1is divirtiendo mientras vais a los entrenamientos y, al mismo tiempo, trabaj\xE1is duro.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 32-title\" style=\"top:767px;left:330px\" src=\"/111/es/static/_content/32-title.png\">\n\n      <img class=\"halfScale 32-line\" style=\"top:951px;left:634px\" src=\"/111/es/static/_content/32-line.png\">\n\n      <img class=\"halfScale 32-sub\" style=\"top:950px;left:672px\" src=\"/111/es/static/_content/32-sub.png\">\n\n      <img class=\"halfScale pointer 32-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax()\n          pg32Anim.fromTo(cOf(\"32-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"32-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"32-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"32-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  LA FIE ANUNCIA MEDIDAS DE SEGURIDAD LAUSANA, SUIZA 11 DE MARZO DE 2019",
    "mobileHtml": "\n      <h2>LA FIE ANUNCIA MEDIDAS DE SEGURIDAD</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/32.jpg\">\n      <p><b>LAUSANA, SUIZA<br>\n      11 DE MARZO DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 33-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"https://fie.org/fie/documents/safe-sport\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:631px;left:57px\" src=\"/111/es/static/_content/i-green.png\">\n      </a>\n      <a href=\"https://static.fie.org/uploads/20/104466-FIE%20Statutes%20ang.pdf\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:794px;left:59px\" src=\"/111/es/static/_content/i-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <a href=\"https://youtu.be/75ZcNY3wsCY\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"top:964px;left:931px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n      </a>\n      <a href=\"https://youtu.be/W4Ce0d6S_-A\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"top:964px;left:1180px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax()\n          pg33Anim\n            .fromTo(cOf(\"33-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Pulse aquí para más INFORMACIÓN  Pulse aquí para ver la política aprobada por el Congreso FIE 2018  La Federación Internacional de Esgrima (FIE) ha anunciado una Política de seguridad integral, cuyo objetivo es proporcionar a los atletas y no atletas un entorno en el que puedan practicar la esgrima de manera segura y en el que los atletas puedan desenvolverse de forma armoniosa y libre.  seguridad de la FIE a las pruebas principales. Estos Oficiales se encargarán de supervisar la política y su aplicación. En Torun, los Oficiales de seguridad asignados fueron el Sr. Sam Cheris (EE. UU.) y la Sra. Georgina Usher (GBR). ■  Aprobada por el Congreso Anual de la FIE en diciembre de 2018 en París, la Política de seguridad promueve la igualdad de oportunidades y prohíbe las prácticas discriminatorias. Exige que cada persona, sea atleta o no, tenga derecho a ser tratada con respeto y dignidad, y a ser protegida frente a todas las formas de acoso y abuso. La FIE se dedica a crear un impacto duradero y sostenible con este enfoque coherente, que se implementará notablemente en los Campeonatos del Mundo. Por ejemplo, en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun, Polonia, del 6 al 14 de abril, un stand especial de seguridad por parte de la FIE proporcionó información e instrucción a los atletas, entrenadores, oficiales, voluntarios y visitantes. Además, se asignarán Oficiales de  Pulse abajo para ver el contenido vídeo del Comité Olímpico Internacional (COI) sobre Safe Sport :  W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>La Federaci\xF3n Internacional de Esgrima (FIE) ha anunciado una Pol\xEDtica de seguridad integral, cuyo objetivo es proporcionar a los atletas y no atletas un entorno en el que puedan practicar la esgrima de manera segura y en el que los atletas puedan desenvolverse de forma armoniosa y libre.</b></p>\n      <p>Aprobada por el Congreso Anual de la FIE en diciembre de 2018 en Par\xEDs, la Pol\xEDtica de seguridad promueve la igualdad de oportunidades y proh\xEDbe las pr\xE1cticas discriminatorias. Exige que cada persona, sea atleta o no, tenga derecho a ser tratada con respeto y dignidad, y a ser protegida frente a todas las formas de acoso y abuso.</p>\n      <p>La FIE se dedica a crear un impacto duradero y sostenible con este enfoque coherente, que se implementar\xE1 notablemente en los Campeonatos del Mundo. Por ejemplo, en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun, Polonia, del 6 al 14 de abril, un stand especial de seguridad por parte de la FIE proporcion\xF3 informaci\xF3n e instrucci\xF3n a los atletas, entrenadores, oficiales, voluntarios y visitantes. Adem\xE1s, se asignar\xE1n Oficiales de seguridad de la FIE a las pruebas principales. Estos Oficiales se encargar\xE1n de supervisar la pol\xEDtica y su aplicaci\xF3n. En Torun, los Oficiales de seguridad asignados fueron el Sr. Sam Cheris (EE. UU.) y la Sra. Georgina Usher (GBR</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:193px;right:633px;width:180px; height:30px;\">\n          <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:198px;right:844px;width:30px; height:30px;\">\n          <a href=\"https://www.facebook.com/uhlmann.fencing/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:198px;right:813px;width:30px; height:30px;\">\n          <a href=\"http://www.instagram.com/Uhlmann.Fencing\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\">\n          <img src=\"/111/es/static/_mobile/34.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/111/es/static/_mobile/35.png\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 36-title\" style=\"top:108px;left:307px\" src=\"/111/es/static/_content/36-title.png\">\n\n      <img class=\"halfScale 36-line\" style=\"top:277px;left:315px\" src=\"/111/es/static/_content/36-line.png\">\n\n      <img class=\"halfScale 36-sub\" style=\"top:276px;left:351px\" src=\"/111/es/static/_content/36-sub.png\">\n\n      <img class=\"halfScale pointer 36-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax()\n          pg36Anim.fromTo(cOf(\"36-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"36-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"36-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"36-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  LA ESGRIMA MUNDIAL SE UNE A #WHITECARD TORUN, POLONIA 6 DE ABRIL DE 2019",
    "mobileHtml": "\n      <h2>LA ESGRIMA MUNDIAL SE UNE A #WHITECARD</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/36.jpg\">\n      <p><b>TORUN, POLONIA<br>\n      6 DE ABRIL DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 37-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax()\n          pg37Anim\n            .fromTo(cOf(\"37-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Con la tarjeta blanca de la paz en conmemoración del Día Internacional del Deporte para el Desarrollo y la Paz, la Federación Internacional de Esgrima (FIE) viajó a Torun, Polonia, donde se celebraron los Campeonatos del Mundo de Esgrima junior y cadete de 2019. La tarjeta #WhiteCard simboliza el apoyo de los atletas a la paz a través del deporte en todo el mundo. El color blanco representa la pureza y la paz y, por lo tanto, se utiliza para representar la positividad y el espíritu constructivo en el deporte. El campeón olímpico de sable de Italia, Aldo Montano, que también es presidente de la Comisión de Atletas de la FIE, dirigió los esfuerzos mientras interactuaba con jóvenes tiradores de países en vías de desarrollo.  oficiales y entrenadores, así como al llevar un mensaje subyacente de paz, comunicación y energía positiva al mundo de la esgrima y más allá. Otros miembros de la Comisión de Atletas de la FIE estuvieron presentes en los Campeonatos del Mundo de Esgrima júnior y cadete para reunirse y participar en varios programas previstos, entre ellos Glaydys Sakoa (CIV), que participó en el Curso de entrenamiento de la FIE; Maria Luisa Doig (PER), que se unió al Curso de entrenamiento y a la iniciativa Deporte Seguro; y Benjamin Kleibrink (GER), que estuvo presente en el Curso de entrenamiento y también apoyó el programa «Donate Your Fencing Gear!». Aldo Montano también participó en el Curso de entrenamiento de la FIE.  #IDSDP2019 (hashtag oficial del día), #WhiteCard y #Sport4BetterWorld. ■  La FIE patrocina programas como permitir que las donaciones de equipos de atletas de élite beneficien a los tiradores desfavorecidos de los países en vías de desarrollo. Estos programas abarcan mucho más que el desarrollo del deporte al construir relaciones y principios positivos para la competición y la interacción entre atletas, W W W.FIE .ORG",
    "mobileHtml": "\n        <p><b>Con la tarjeta blanca de la paz en conmemoraci\xF3n del D\xEDa Internacional del Deporte para el Desarrollo y la Paz, la Federaci\xF3n Internacional de Esgrima (FIE) viaj\xF3 a Torun, Polonia, donde se celebraron los Campeonatos del Mundo de Esgrima junior y cadete de 2019.</b></p>\n\n        <p>La tarjeta #WhiteCard simboliza el apoyo de los atletas a la paz a trav\xE9s del deporte en todo el mundo. El color blanco representa la pureza y la paz y, por lo tanto, se utiliza para representar la positividad y el esp\xEDritu constructivo en el deporte.</p>\n\n        <p>El campe\xF3n ol\xEDmpico de sable de Italia, Aldo Montano, que tambi\xE9n es presidente de la Comisi\xF3n de Atletas de la FIE, dirigi\xF3 los esfuerzos mientras interactuaba con j\xF3venes tiradores de pa\xEDses en v\xEDas de desarrollo.</p>\n\n        <p>La FIE patrocina programas como permitir que las donaciones de equipos de atletas de \xE9lite beneficien a los tiradores desfavorecidos de los pa\xEDses en v\xEDas de desarrollo. Estos programas abarcan mucho m\xE1s que el desarrollo del deporte al construir relaciones y principios positivos para la competici\xF3n y la interacci\xF3n entre atletas, oficiales y entrenadores, as\xED como al llevar un mensaje subyacente de paz, comunicaci\xF3n y energ\xEDa positiva al mundo de la esgrima y m\xE1s all\xE1.</p>\n\n        <p>Otros miembros de la Comisi\xF3n de Atletas de la FIE estuvieron presentes en los Campeonatos del Mundo de Esgrima j\xFAnior y cadete para reunirse y participar en varios programas previstos, entre ellos Glaydys Sakoa (CIV), que particip\xF3 en el Curso de entrenamiento de la FIE; Maria Luisa Doig (PER), que se uni\xF3 al Curso de entrenamiento y a la iniciativa Deporte Seguro; y Benjamin Kleibrink (GER), que estuvo presente en el Curso de entrenamiento y tambi\xE9n apoy\xF3 el programa \xC1Donate Your Fencing Gear!\xC8. Aldo Montano tambi\xE9n particip\xF3 en el Curso de entrenamiento de la FIE.</p>\n\n        <p>#IDSDP2019 (hashtag oficial del d\xEDa),  #WhiteCard y #Sport4BetterWorld.</p>\n      "

  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 38-title\" style=\"top:771px;left:64px\" src=\"/111/es/static/_content/38-title.png\">\n\n      <img class=\"halfScale 38-line\" style=\"top:1010px;left:1040px\" src=\"/111/es/static/_content/38-line.png\">\n\n      <img class=\"halfScale 38-sub\" style=\"top:1009px;left:1075px\" src=\"/111/es/static/_content/38-sub.png\">\n\n      <img class=\"halfScale pointer 38-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax()\n          pg38Anim.fromTo(cOf(\"38-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"38-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"38-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"38-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  LA ESGRIMA INTERNACIONAL CELEBRA EL «DÍA DE PLAY TRUE» DE LA AMA  TORUN, POLONIA ABRIL 10, 2019",
    "mobileHtml": "\n      <h2>LA ESGRIMA INTERNACIONAL CELEBRA EL \xC1D\xCDA DE PLAY TRUE DE LA AMA\xC8</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/38.jpg\">\n      <p><b>TORUN, POLONIA<br>\n      10 DE ABRIL DE 2019</b></p>\n      "

  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 39-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax()\n          pg39Anim\n            .fromTo(cOf(\"39-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Como parte del «Día de Play True» de la Agencia Mundial Antidopaje (AMA), la Federación Internacional de Esgrima (FIE) participó en una celebración e iniciativa mundial para promover el deporte limpio y sensibilizar a los atletas. El esfuerzo general se dedicó a educar e informar al público deportivo y a otros sobre la lucha mundial contra el dopaje. La FIE ofrece un programa educativo formal para el Deporte Limpio, y los miembros de la comisión médica de la Federación estuvieron presentes en los Campeonatos del Mundo Junior y Cadete de Esgrima de 2019 en Torun, Polonia, para trabajar uno a uno con atletas y entrenadores. También participaron campeones del mundo y atletas olímpicos para representar la importancia del programa. «Nuestra meta es sensibilizar a la comunidad de esgrima, y es importante porque nuestros programas y el Día de Play True se centran en ayudar a los atletas a aprender sobre los peligros del dopaje y a involucrarlos en el espíritu del Deporte Limpio», dijo la Dra. Sabrina Imene Halaimia (ALG), miembro de la Comisión Médica de la FIE. «Queremos que los atletas aprendan a decir “No al dopaje” en todo el mundo y en todas las disciplinas deportivas».■  W W W.FIE .ORG",
    "mobileHtml": "\n        <p><b>Como parte del D\xEDa de Play True de la Agencia Mundial Antidopaje (AMA), la Federaci\xF3n Internacional de Esgrima (FIE) particip\xF3 en una celebraci\xF3n e iniciativa mundial para promover el deporte limpio y sensibilizar a los atletas.</b></p>\n\n        <p>El esfuerzo general se dedic\xF3 a educar e informar al p\xFAblico deportivo y a otros sobre la lucha mundial contra el dopaje.</p>\n\n        <p>La FIE ofrece un programa educativo formal para el Deporte Limpio, y los miembros de la comisi\xF3n m\xE9dica de la Federaci\xF3n estuvieron presentes en los Campeonatos del Mundo Junior y Cadete de Esgrima de 2019 en Torun, Polonia, para trabajar uno a uno con atletas y entrenadores. Tambi\xE9n participaron campeones del mundo y atletas ol\xEDmpicos para representar la importancia del programa.</p>\n\n        <p>Nuestra meta es sensibilizar a la comunidad de esgrima, y es importante porque nuestros programas y el D\xEDa de Play True se centran en ayudar a los atletas a aprender sobre los peligros del dopaje y a involucrarlos en el esp\xEDritu del Deporte Limpio\xC8, dijo la Dra. Sabrina Imene Halaimia (ALG), miembro de la Comisi\xF3n M\xE9dica de la FIE. \xC1Queremos que los atletas aprendan a decir \xDANo al dopaje\xD3 en todo el mundo y en todas las disciplinas deportivas</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:330px;right:898px;width:620px; height:54px;\">\n          <a href=\"http://www.fencewithfun.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:180px;right:964px;width:210px; height:27px;\">\n          <a href=\"http://www.fencewithfun.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:180px;right:1240px;width:220px; height:27px;\">\n          <a href=\"mailto:info@fencewithfun.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.fencewithfun.com\" target=\"_blank\">\n        <img src=\"/111/es/static/_mobile/40.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:143px;right:40px;width:720px; height:48px;\">\n          <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\">\n        <img src=\"/111/es/static/_mobile/41.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 42-title\" style=\"top:561px;left:83px\" src=\"/111/es/static/_content/42-title.png\">\n\n      <img class=\"halfScale 42-line\" style=\"top:1001px;left:85px\" src=\"/111/es/static/_content/42-line.png\">\n\n      <img class=\"halfScale 42-sub\" style=\"top:1000px;left:121px\" src=\"/111/es/static/_content/42-sub.png\">\n\n      <img class=\"halfScale pointer 42-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax()\n          pg42Anim.fromTo(cOf(\"42-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"42-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"42-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"42-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  ¡HUNGRÍA SE UNE AL PROGRAMA DONATE YOUR FENCING GEAR! TORUN, POLONIA 22 DE ABRIL DE 2019",
    "mobileHtml": "\n      <h2>HUNGR\xCDA SE UNE AL PROGRAMA DONATE YOUR FENCING GEAR!</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/42.jpg\">\n      <p><b>TORUN, POLONIA<br>\n      22 DE ABRIL DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 43-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax()\n          pg43Anim\n            .fromTo(cOf(\"43-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/3  La Federación Húngara de Esgrima (HFF) se ha unido al programa «Donate your Fencing Gear» de la FIE, que proporciona a organizaciones e individuos desfavorecidos de múltiples países equipos de esgrima de buena calidad donados por tiradores y federaciones. La HFF ha apoyado el programa desde su inicio y anima a las federaciones y los tiradores de todo el mundo a unirse a sus esfuerzos filantrópicos. Muchos tiradores húngaros de élite han participado personalmente en el desarrollo del programa: El campeón del mundo de esgrima por equipos húngaro, Gabor Boczko, fue el  primer tirador en donar al programa en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2017 en Plovdiv, Bulgaria, donde entregó su careta y el guante que usó en los Juegos Olímpicos de Río 2016. Los medallistas de oro olímpicos Aron Szilagyi y Emese SzaszKovacs donaron equipo personal en los Campeonatos del Mundo de Esgrima Senior de",
    "mobileHtml": "\n        <p><b>La Federaci\xF3n H\xFAngara de Esgrima (HFF) se ha unido al programa \xC1Donate your Fencing Gear\xC8 de la FIE, que proporciona a organizaciones e individuos desfavorecidos de m\xFAltiples pa\xEDses equipos de esgrima de buena calidad donados por tiradores y federaciones.</b></p>\n\n        <p>La HFF ha apoyado el programa desde su inicio y anima a las federaciones y los tiradores de todo el mundo a unirse a sus esfuerzos filantr\xF3picos.</p>\n\n        <p>Muchos tiradores h\xFAngaros de \xE9lite han participado personalmente en el desarrollo del programa: El campe\xF3n del mundo de esgrima por equipos h\xFAngaro, Gabor Boczko, fue el primer tirador en donar al programa en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2017 en Plovdiv, Bulgaria, donde entreg\xF3 su careta y el guante que us\xF3 en los Juegos Ol\xEDmpicos de R\xEDo 2016. Los medallistas de oro ol\xEDmpicos Aron Szilagyi y Emese Szasz-Kovacs donaron equipo personal en los Campeonatos del Mundo de Esgrima Senior de 2017 en Leipzig, Alemania, y el equipo h\xFAngaro de sable masculino hizo donaciones similares en los Campeonatos del Mundo de Esgrima Senior de 2018 en Wuxi, China.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 44-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://fie.org/development/gear\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:794px;left:57px\" src=\"/111/es/static/_content/i-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax()\n          pg44Anim\n            .fromTo(cOf(\"44-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/3  2017 en Leipzig, Alemania, y el equipo húngaro de sable masculino hizo donaciones similares en los Campeonatos del Mundo de Esgrima Senior de 2018 en Wuxi, China. El Sr. Boczko, con vista a la esgrima húngara y al Campeonato del Mundo de Esgrima Senior de 2019 que se celebró en Budapest, está coordinando un programa de donación en toda Hungría para que los clubes de esgrima se sumen a los esfuerzos de donación de equipos. La HFF entregó oficialmente el equipo a la  FIE durante el Campeonato de verano 2019 y esperaban inspirar a otros para que participen y lleven equipos a Budapest. En los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun, Polonia, el Sr. Boczko estuvo presente para promover el programa en nombre de la HFF y para alentar personalmente las donaciones. «Es un programa excelente y creemos que es muy importante ayudar a los tiradores más desfavorecidos», dijo. Cada año, los países presentan solicitudes para recibir donaciones, que son seleccionadas y otorgadas por la FIE. Los donantes pueden elegir los países receptores para su equipo o solicitar a la FIE que los seleccione por ellos. Los países receptores seleccionados y oficiales de este año son Brasil, Colombia, Kirguistán, Nigeria, Serbia y Yemen. ■  Pulse aquí para obtener más INFORMACIÓN sobre el programa  W W W.FIE .ORG",
    "mobileHtml": "\n      <p>El Sr. Boczko, con vista a la esgrima h\xFAngara y al Campeonato del Mundo de Esgrima Senior de 2019 que se celebr\xF3 en Budapest, est\xE1 coordinando un programa de donaci\xF3n en toda Hungr\xEDa para que los clubes de esgrima se sumen a los esfuerzos de donaci\xF3n de equipos. La HFF entreg\xF3 oficialmente el equipo a la FIE durante el Campeonato de verano 2019 y esperaban inspirar a otros para que participen y lleven equipos a Budapest.</p>\n\n      <p>En los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun, Polonia, el Sr. Boczko estuvo presente para promover el programa en nombre de la HFF y para alentar personalmente las donaciones. \xC1Es un programa excelente y creemos que es muy importante ayudar a los tiradores m\xE1s desfavorecidos\xC8, dijo.</p>\n\n      <p>Cada a\xF1o, los pa\xEDses presentan solicitudes para recibir donaciones, que son seleccionadas y otorgadas por la FIE. Los donantes pueden elegir los pa\xEDses receptores para su equipo o solicitar a la FIE que los seleccione por ellos. Los pa\xEDses receptores seleccionados y oficiales de este a\xF1o son Brasil, Colombia, Kirguist\xE1n, Nigeria, Serbia y Yemen.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 45-title\" style=\"top:818px;left:109px\" src=\"/111/es/static/_content/45-title.png\">\n\n      <img class=\"halfScale 45-line\" style=\"top:1001px;left:112px\" src=\"/111/es/static/_content/45-line.png\">\n\n      <img class=\"halfScale 45-sub\" style=\"top:1000px;left:149px\" src=\"/111/es/static/_content/45-sub.png\">\n\n      <img class=\"halfScale pointer 45-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax()\n          pg45Anim.fromTo(cOf(\"45-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"45-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"45-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"45-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  REUNIÓN DE LAS COMISIONES Y LOS CONSEJOS DE LA FIE BUCAREST, RUMANIA 28-30 DE JUNIO DE 2019",
    "mobileHtml": "\n      <h2>REUNI\xD3N DE LAS COMISIONES Y LOS CONSEJOS DE LA FIE</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/45.jpg\">\n      <p><b>BUCAREST, RUMANIA<br>\n      28-30 DE JUNIO DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 46-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax()\n          pg46Anim\n            .fromTo(cOf(\"46-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  La reunión anual de las Comisiones y los Consejos de la FIE se celebró en Bucarest (ROU) entre el 28 y el 30 de junio de 2019, el último fin de semana del mes. Se desarrollaron dos sesiones plenarias además de la agenda individual de cada organismo técnico. Se organizó un curso de formación para supervisores de competencias la mañana del 28 de junio. El taller lo dirigió Pascal Tesch, miembro del Comité Ejecutivo de la FIE y representante del Comité Ejecutivo en la Comisión de los Reglamentos, y Edina Czegledy, miembro de la Comisión Jurídica de la FIE. Además, lo preparó de forma conjunta un grupo de trabajo especial compuesto por Pascal Tesch y Edina Czegledy, así como por el Presidente de la Comisión Jurídica de la FIE, Sam Cheris (EE. UU., MH); Clare Halstead (GBR), Presidenta del Consejo Antidopaje de la FIE; y Nathalie Rodríguez, Directora General de la FIE. En el seminario se destacó el marco jurídico de las responsabilidades de los supervisores, así como las mejores prácticas,  con el fin de homogeneizar los estándares. Se presentó un sistema actualizado de presentación de informes. El domingo, tuvo lugar una sesión de formación sobre Protección para los supervisores, en la que se detallaron los nuevos procedimientos de Protección aprobados por el Comité Ejecutivo e incorporados en el Reglamento Administrativo de la FIE después de que el Congreso de 2018 aprobase la Política de Protección de la FIE. La formación de los supervisores en materia de Protección la impartieron de forma conjunta Kirsty Burrows, Oficial de Profección del COI, y Maria Putz, experta de la organización LimeCulture. La formación específica de los Responsables de la Protección de la FIE nombrados en los campeonatos del mundo ya había tenido lugar en febrero. Entre otros puntos del orden del día, las Comisiones y los Consejos examinaron las propuestas de modificación de los Estatutos y el Reglamento. ■  W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>La reuni\xF3n anual de las Comisiones y los Consejos de la FIE se celebr\xF3 en Bucarest (ROU) entre el 28 y el 30 de junio de 2019, el \xFAltimo fin de semana del mes.</b></p>\n\n      <p>Se desarrollaron dos sesiones plenarias adem\xE1s de la agenda individual de cada organismo t\xE9cnico. Se organiz\xF3 un curso de formaci\xF3n para supervisores de competencias la ma\xF1ana del 28 de junio. El taller lo dirigi\xF3 Pascal Tesch, miembro del Comit\xE9 Ejecutivo de la FIE y representante del Comit\xE9 Ejecutivo en la Comisi\xF3n de los Reglamentos, y Edina Czegledy, miembro de la Comisi\xF3n Jur\xEDdica de la FIE. Adem\xE1s, lo prepar\xF3 de forma conjunta un grupo de trabajo especial compuesto por Pascal Tesch y Edina Czegledy, as\xED como por el Presidente de la Comisi\xF3n Jur\xEDdica de la FIE, Sam Cheris (EE. UU., MH); Clare Halstead (GBR), Presidenta del Consejo Antidopaje de la FIE; y Nathalie Rodr\xEDguez, Directora General de la FIE. En el seminario se destac\xF3 el marco jur\xEDdico de las responsabilidades de los supervisores, as\xED como las mejores pr\xE1cticas, con el fin de homogeneizar los est\xE1ndares. Se present\xF3 un sistema actualizado de presentaci\xF3n de informes.</p>\n\n      <p>El domingo, tuvo lugar una sesi\xF3n de formaci\xF3n sobre Protecci\xF3n para los supervisores, en la que se detallaron los nuevos procedimientos de Protecci\xF3n aprobados por el Comit\xE9\n      Ejecutivo e incorporados en el Reglamento Administrativo de la FIE despu\xE9s de que el Congreso de 2018 aprobase la Pol\xEDtica de Protecci\xF3n de la FIE. La formaci\xF3n de los supervisores en materia de Protecci\xF3n la impartieron de forma conjunta Kirsty Burrows, Oficial de Profecci\xF3n del COI, y Maria Putz, experta de la organizaci\xF3n LimeCulture. La formaci\xF3n espec\xEDfica de los Responsables de la Protecci\xF3n de la FIE nombrados en los campeonatos del mundo ya hab\xEDa tenido lugar en febrero.</p>\n\n      <p>Entre otros puntos del orden del d\xEDa, las Comisiones y los Consejos examinaron las propuestas de modificaci\xF3n de los Estatutos y el Reglamento.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 47-title\" style=\"top:757px;left:67px\" src=\"/111/es/static/_content/47-title.png\">\n\n      <img class=\"halfScale 47-line\" style=\"top:1018px;left:69px\" src=\"/111/es/static/_content/47-line.png\">\n\n      <img class=\"halfScale 47-sub\" style=\"top:1018px;left:106px\" src=\"/111/es/static/_content/47-sub.png\">\n\n      <img class=\"halfScale pointer 47-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax()\n          pg47Anim.fromTo(cOf(\"47-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"47-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"47-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"47-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  NEPAL CELEBRA LOS CAMPEONATOS NACIONALES DE ESGRIMA BANKE, NEPALGUNJ, NEPAL 11-14 DE ABRIL DE 2019",
    "mobileHtml": "\n      <h2>NEPAL CELEBRA LOS CAMPEONATOS NACIONALES DE ESGRIMA</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/47.jpg\">\n      <p><b>BANKE, NEPALGUNJ, NEPAL<br>\n      11 AL 14 DE ABRIL DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 48-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('48-pop')\" style=\"top:792px;left:59px\" src=\"/111/es/static/_content/medal-green.png\">\n\n      <div id=\"48-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/48-pop.png\">\n        <div class=\"contentLink\" style=\"top: 182px; left: 1081px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('48-pop');\"></div>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax()\n          pg48Anim\n            .fromTo(cOf(\"48-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop()\n          hideOverlay('48-pop');\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Con el apoyo del Consejo Nacional de Deportes de Nepal, el cuarto Campeonato Nacional de Esgrima del país tuvo lugar en Banke, Nepalgunj, del 11 al 14 de abril. El Campeonato, que se celebró en el marco de los octavos Juegos Nacionales de Nepal, atrajo a más tiradores que en años anteriores, y fue la primera vez que las pruebas se realizaron fuera de la capital de Katmandú. Las ceremonias de apertura fueron inauguradas por el levantador de pesas olímpico nepalés Surendra Hamal. El Campeonato contó con la participación de 129 tiradores de cuatro provincias y tres clubes «departamentales» que compitieron en 12 pruebas individuales y por equipos. El Ejército de Nepal se llevó el mayor número de medallas, seguido por el Club APF y la Provincia Nº 3.  Pulse aquí para ver los MEDALLISTAS DE ORO  La ceremonia de entrega de medallas, celebrada el último día, contó con la presencia de varios dignatarios, entre ellos un invitado principal, el Sr. Keshav Kumar Bista, secretario del Consejo Nacional de Deportes y presidente de la Secretaría del Comité Organizador de los Octavos Juegos Nacionales; el invitado especial, el Sr. Ratan Tandon, tesorero del Comité Olímpico  de Nepal; el Sr. Sunil Kumar Shrestha, presidente de la Asociación Nepalesa de Esgrima; y el Sr. Sujan Lal Shrestha, secretario general de la Asociación de Esgrima de Nepal. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>Con el apoyo del Consejo Nacional de Deportes de Nepal, el cuarto Campeonato Nacional de Esgrima del pa\xEDs tuvo lugar en Banke, Nepalgunj, del 11 al 14 de abril.</b></p>\n\n      <p>El Campeonato, que se celebr\xF3 en el marco de los octavos Juegos Nacionales de Nepal, atrajo a m\xE1s tiradores que en a\xF1os anteriores, y fue la primera vez que las pruebas se realizaron fuera de la capital de Katmand\xFA. Las ceremonias de apertura fueron inauguradas por el levantador de pesas ol\xEDmpico nepal\xE9s Surendra Hamal.</p>\n\n      <p>El Campeonato cont\xF3 con la participaci\xF3n de 129 tiradores de cuatro provincias y tres clubes \xC1departamentales\xC8 que compitieron en 12 pruebas individuales y por equipos. El Ej\xE9rcito de Nepal se llev\xF3 el mayor n\xFAmero de medallas, seguido por el Club APF y la Provincia N\xBC 3.</p>\n\n      <p>La ceremonia de entrega de medallas, celebrada el \xFAltimo d\xEDa, cont\xF3 con la presencia de varios dignatarios, entre ellos un invitado principal, el Sr. Keshav Kumar Bista, secretario del Consejo Nacional de Deportes y presidente de la Secretar\xEDa del Comit\xE9 Organizador de los Octavos Juegos Nacionales; el invitado especial, el Sr. Ratan Tandon, tesorero del Comit\xE9 Ol\xEDmpico de Nepal; el Sr. Sunil Kumar Shrestha, presidente de la Asociaci\xF3n Nepalesa de Esgrima; y el Sr. Sujan Lal Shrestha, secretario general de la Asociaci\xF3n de Esgrima de Nepal.</p>\n\n      <h2>Los medallistas de oro incluyeron a los siguientes:</h2>\n\n      <h4>Florete</h4>\n      <p>MASCULINO INDIVIDUAL:<br> <b>Jalindra Shahi, Ej\xE9rcito de Nepal</b></p>\n      <p>FEMENINO INDIVIDUAL:<br> <b>Mandira Thapa, Club APF</b></p>\n      <p>MASCULINO POR EQUIPOS:<br> <b>Ej\xE9rcito de Nepal</b></p>\n      <p>FEMENINA POR EQUIPOS:<br> <b>Club APF</b></p>\n\n      <h4>Espada</h4>\n      <p>MASCULINO INDIVIDUAL:<br> <b>Omkar Singh, Provincia 3</b></p>\n      <p>FEMENINO INDIVIDUAL:<br> <b>Indira Poudel, Ej\xE9rcito de Nepal</b></p>\n      <p>MASCULINO POR EQUIPOS:<br> <b>Club APF</b></p>\n      <p>FEMENINA POR EQUIPOS:<br> <b>Ej\xE9rcito de Nepal</b></p>\n\n      <h4>Sable</h4>\n      <p>MASCULINO INDIVIDUAL:<br> <b>Amit Bhandari, Provincia 3</b></p>\n      <p>FEMENINO INDIVIDUAL:<br> <b>Kamal Shrestha, Ej\xE9rcito de Nepal</b></p>\n      <p>MASCULINO POR EQUIPOS:<br><b>Provincia 3</b></p>\n      <p>FEMENINA POR EQUIPOS:<br> <b>Ej\xE9rcito de Nepal</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:391px;right:771px;width:210px; height:33px;\">\n          <a href=\"http://www.gfencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:391px;right:550px;width:210px; height:33px;\">\n          <a href=\"mailto:sales@gfencing.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/111/es/static/_mobile/49.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 50-title\" style=\"top:197px;left:82px\" src=\"/111/es/static/_content/50-title.png\">\n\n      <img class=\"halfScale 50-line\" style=\"top:528px;left:90px\" src=\"/111/es/static/_content/50-line.png\">\n\n      <img class=\"halfScale 50-sub\" style=\"top:528px;left:126px\" src=\"/111/es/static/_content/50-sub.png\">\n\n      <img class=\"halfScale pointer 50-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax()\n          pg50Anim.fromTo(cOf(\"50-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"50-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"50-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"50-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  SE DESARROLLA LA ESGRIMA EN SAMOA AMERICANA Y SAMOA SAMOA AMERICANA/SAMOA",
    "mobileHtml": "\n      <h2>SE DESARROLLA LA ESGRIMA EN SAMOA AMERICANA Y SAMOA</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/50.jpg\">\n      <p><b>SAMOA AMERICANA/SAMOA</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 51-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax()\n          pg51Anim\n            .fromTo(cOf(\"51-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg51Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/3  Las federaciones de esgrima de Samoa Americana y Samoa, beneficiarias del programa Donate Your Fencing Gear! 2018 de la FIE, han estado desarrollando activamente la esgrima en su región. Según lo informado por las federaciones, utilizando el equipo donado por la FIE, han aumentado el número de tiradores en general y han permitido a los atletas experimentados participar en pruebas de alto nivel. El equipo recibido por las federaciones de Samoa incluía una variedad de donaciones en múltiples tamaños, incluyendo artículos más pequeños (que son más difíciles de conseguir). Esto ha dado a las federaciones la capacidad  de ofrecer esgrima a los niños más pequeños, dándoles una ventaja para convertirse en atletas exitosos. El equipo donado ha elevado efectivamente los estándares generales de seguridad del equipo de esgrima que se utiliza en la práctica y en las pruebas. Con la ayuda de las donaciones, las federaciones planean aumentar su alcance en las comunidades insulares mediante programas de reclutamiento concertados en",
    "mobileHtml": "\n      <p><b>Las federaciones de esgrima de Samoa Americana y Samoa, beneficiarias del programa Donate Your Fencing Gear! 2018 de la FIE, han estado desarrollando activamente la esgrima en su regi\xF3n.</b></p>\n      <p>Seg\xFAn lo informado por las federaciones, utilizando el equipo donado por la FIE, han aumentado el n\xFAmero de tiradores en general y han permitido a los atletas experimentados participar en pruebas de alto nivel.</p>\n      <p>El equipo recibido por las federaciones de Samoa inclu\xEDa una variedad de donaciones en m\xFAltiples tama\xF1os, incluyendo art\xEDculos m\xE1s peque\xF1os (que son m\xE1s dif\xEDciles de conseguir). Esto ha dado a las federaciones la capacidad de ofrecer esgrima a los ni\xF1os m\xE1s peque\xF1os, d\xE1ndoles una ventaja para convertirse en atletas exitosos. El equipo donado ha elevado efectivamente los est\xE1ndares generales de seguridad del equipo de esgrima que se utiliza en la pr\xE1ctica y en las pruebas.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 52-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax()\n          pg52Anim\n            .fromTo(cOf(\"52-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/3  las escuelas. Además, las donaciones de equipo y los programas de desarrollo ayudarán a los tiradores de Samoa a competir y entrenar en tres armas con los países vecinos de Oceanía, incluyendo Nueva Caledonia, Tahití, Guam, Australia y Nueva Zelanda. En marzo, celebraron un campeonato inaugural de la federación combinada «All-Samoan Championships», junto con un programa de entrenamiento y desarrollo dirigido a los atletas jóvenes. Las sesiones dirigidas por el oficial de Desarrollo Regional, Leon Thomas, y el director regional de Deportes, Peter Creese, proporcionaron a seis atletas de Samoa y Samoa Americana actividades de entrenamiento que  van desde el juego de pies, ejercicios técnicos y de acondicionamiento físico hasta información detallada sobre los reglamentos de la prueba y la esgrima en general, el arbitraje y la gestión de pruebas. El campeonato de los All-Samoan contó con diez tiradores en florete juveniles (seis de Samoa Americana y cuatro de Samoa) en una prueba mixta que incluyó una final por separado para las atletas femeninas. El ucraniano Gregorio (ASA) se llevó el oro en florete masculino juveniles, y Barbara Roache (SAM) ganó en florete femenino juveniles. El campeonato también incluyó una prueba de florete por equipos entre los dos países, con Samoa Americana ganando, 45-13. Las pruebas atrajeron a espectadores locales y a los medios de comunicación, y ayudaron a preparar a varios de los atletas para una prueba regional más amplia, como el Campeonato Cadetes de Oceanía a finales de abril en Wellington, Nueva Zelanda. El equipo donado por el programa Donate Your Fencing Gear! de la FIE fue utilizado por los tiradores de Samoa tanto en el entrenamiento como en la prueba.■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p>Con la ayuda de las donaciones, las federaciones planean aumentar su alcance en las comunidades insulares mediante programas de reclutamiento concertados en las escuelas. Adem\xE1s, las donaciones de equipo y los programas de desarrollo ayudar\xE1n a los tiradores de Samoa a competir y entrenar en tres armas con los pa\xEDses vecinos de Ocean\xEDa, incluyendo Nueva Caledonia, Tahit\xED, Guam, Australia y Nueva Zelanda.</p>\n      <p>En marzo, celebraron un campeonato inaugural de la federaci\xF3n combinada \xC1All-Samoan Championships\xC8, junto con un programa de entrenamiento y desarrollo dirigido a los atletas j\xF3venes. Las sesiones dirigidas por el oficial de Desarrollo Regional, Leon Thomas, y el director regional de Deportes, Peter Creese, proporcionaron a seis atletas de Samoa y Samoa Americana actividades de entrenamiento que van desde el juego de pies, ejercicios t\xE9cnicos y de acondicionamiento f\xEDsico hasta informaci\xF3n detallada sobre los reglamentos de la prueba y la esgrima en general, el arbitraje y la gesti\xF3n de pruebas.</p>\n      <p>El campeonato de los All-Samoan cont\xF3 con diez tiradores en florete juveniles (seis de Samoa Americana y cuatro de Samoa) en una prueba mixta que incluy\xF3 una final por separado para las atletas femeninas. El ucraniano Gregorio (ASA) se llev\xF3 el oro en florete masculino juveniles, y Barbara Roache (SAM) gan\xF3 en florete femenino juveniles.\n      El campeonato tambi\xE9n incluy\xF3 una prueba de florete por equipos entre los dos pa\xEDses, con Samoa Americana ganando, 45-13. Las pruebas atrajeron a espectadores locales y a los medios de comunicaci\xF3n, y ayudaron a preparar a varios de los atletas para una prueba regional m\xE1s amplia, como el Campeonato Cadetes de Ocean\xEDa a finales de abril en Wellington, Nueva Zelanda..</p>\n      <p>El equipo donado por el programa Donate Your Fencing Gear! de la FIE fue utilizado por los tiradores de Samoa tanto en el entrenamiento como en la prueba.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 53-title\" style=\"top:107px;left:84px\" src=\"/111/es/static/_content/53-title.png\">\n\n      <img class=\"halfScale 53-line\" style=\"top:363px;left:90px\" src=\"/111/es/static/_content/53-line.png\">\n\n      <img class=\"halfScale 53-sub\" style=\"top:363px;left:126px\" src=\"/111/es/static/_content/53-sub.png\">\n\n      <img class=\"halfScale pointer 53-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax()\n          pg53Anim.fromTo(cOf(\"53-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"53-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"53-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"53-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  STAND DE JUEGO LIMPIO EN TORUN TORUN, POLONIA 28 MAR. 2019",
    "mobileHtml": "\n      <h2>STAND DE JUEGO LIMPIO EN TORU</h2>\n      <img id=\"fwdimg\" src=\"/111/es/static/_mobile/53.jpg\">\n      <p><b>TORUN, POLONIA<br>\n      28 DE MARZO 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 54-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/32-arrow.jpg\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/111/es/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/111/es/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax()\n          pg54Anim\n            .fromTo(cOf(\"54-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Como es habitual, el Consejo del Juego Limpio de la FIE estuvo presente en los Campeonatos del mundo juveniles y en los Campeonatos cadetes. Como parte del Juego limpio enfatizamos la importancia de: Competencia limpia: Para disfrutar plenamente de los honores del éxito, no basta con ganar. El triunfo debe medirse por medios completamente limpios, por la honestidad y por el juego limpio.  Practicar su deporte dentro de un marco ético sólido es vital si desea ser un verdadero campeón. Tolerancia: La capacidad de aceptar conductas o decisiones con las que no está de acuerdo ayuda a desarrollar su propio sentido de autocontrol. Por último, esa capacidad podría ser el factor decisivo a la hora de ganar o perder. Y mucho más. ■ Bert van de Flier (MH) Presidente del Consejo de Juego Limpio de la FIE  Respeto: Cada tirador debe adherirse al reglamento existente por escrito. Es obligatorio. Es igual de importante que cada tirador respete las normas aún no reflejadas por escrito. Y el juego limpio requiere el respeto incondicional hacia sus oponentes, árbitros y aficionados. Amistad: La rivalidad en la pista no excluye la amistad. Al contrario, los sólidos vínculos y amistades de por vida pueden ser el resultado de dos oponentes que lucharon y dieron todo en la pista, pero que se respetaron plenamente. Integridad: La honestidad y los firmes principios morales son esenciales para el juego limpio. W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>Como es habitual, el Consejo del Juego Limpio de la FIE estuvo presente en los Campeonatos del mundo juveniles y en los Campeonatos cadetes.</b></p>\n\n      <p>Como parte del Juego limpio enfatizamos la importancia de:</p>\n\n      <p><b>Competencia limpia:</b> Para disfrutar plenamente de los honores del \xE9xito, no basta con ganar. El triunfo debe medirse por medios completamente limpios, por la honestidad y por el juego limpio.</p>\n\n      <p><b>Respeto:</b> Cada tirador debe adherirse al reglamento existente por escrito. Es obligatorio. Es igual de importante que cada tirador respete las normas a\xFAn no reflejadas por escrito. Y el juego limpio requiere el respeto incondicional hacia sus oponentes, \xE1rbitros y aficionados.</p>\n\n      <p><b>Amistad::</b> La rivalidad en la pista no excluye la amistad. Al contrario, los s\xF3lidos v\xEDnculos y amistades de por vida pueden ser el resultado de dos oponentes que lucharon y dieron todo en la pista, pero que se respetaron plenamente..</p>\n\n      <p><b>Integridad:</b> La honestidad y los firmes principios morales son esenciales para el juego limpio. Practicar su deporte dentro de un marco \xE9tico s\xF3lido es vital si desea ser un verdadero campe\xF3n.</p>\n\n      <p><b>Tolerancia:</b> La capacidad de aceptar conductas o decisiones con las que no est\xE1 de acuerdo ayuda a desarrollar su propio sentido de autocontrol. Por \xFAltimo, esa capacidad podr\xEDa ser el factor decisivo a la hora de ganar o perder.</p>\n\n      <p>Y mucho m\xE1s.</p>\n      <p>Bert van de Flier (MH)<br>\n      Presidente del Consejo de Juego Limpio de la FIE</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:56px;right:625px;width:290px; height:47px;\">\n          <a href=\"http://www.pbtfencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:56px;right:65px;width:331px; height:47px;\">\n          <a href=\"http://www.instagram.com/pbt_fencing/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:56px;right:1185px;width:290px; height:47px;\">\n          <a href=\"mailto:sales@pbtfencing.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"http://www.pbtfencing.com\" target=\"_blank\">\n          <img src=\"/111/es/static/_mobile/55.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 56-arrow\" style=\"top:938px;left:1174px\" onclick=\"Publish.goToNextPage()\" src=\"/111/es/static/_content/56-arrow.jpg\">\n      <img class=\"halfScale 56-title\" style=\"top:133px;left:85px\" src=\"/111/es/static/_content/56-title.png\">\n      <img class=\"halfScale 56-logo\" style=\"top:116px;left:1276px\" src=\"/111/es/static/_content/56-logo.png\">\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <div class=\"addContentLink\" onclick=\"showOverlay('56-pop-1')\" style=\"top:795px;left:155px;width:228px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('56-pop-2')\" style=\"top:981px;left:129px;width:228px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('56-pop-3')\" style=\"top:435px;left:1067px;width:228px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('56-pop-4')\" style=\"top:608px;left:1067px;width:228px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('56-pop-5')\" style=\"top:819px;left:1067px;width:228px;height:36px\"></div>\n\n      <div id=\"56-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/56-pop-bg.jpg\">\n        <img id=\"\" class=\"\" style=\"top:300px;left:81px;\" src=\"/111/es/static/_content/56-pop-1.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1320px; width: 169px; height: 49px;opacity:0\" onclick=\"hideOverlay('56-pop-1');\"></div>\n      </div>\n\n      <div id=\"56-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/56-pop-bg.jpg\">\n        <img id=\"\" class=\"\" style=\"top:150px;left:81px;\" src=\"/111/es/static/_content/56-pop-2.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1320px; width: 169px; height: 49px;opacity:0\" onclick=\"hideOverlay('56-pop-2');\"></div>\n        <a href=\"https://tokyo2020.org/en/news/notice/20190416-01.html\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:742px;left:780px;width:290px; height:30px;\"></div>\n        </a>\n        <a href=\"https://static.fie.org/uploads/20/104615-20190416-%20Tokyo%202020%20Unveils%20Details%20of%20Olympic%20Competition%20Schedule-%20EN.pdf\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:850px;left:1103px;width:324px; height:63px;\"></div>\n        </a>\n        <a href=\"https://static.fie.org/uploads/20/104616-Master%E3%80%91Tokyo%202020%20Olympic%20Competition%20%28Session%29%20Schedule%20v5.00.pdf\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:922px;left:1103px;width:324px; height:63px;\"></div>\n        </a>\n        <a href=\"https://static.fie.org/uploads/20/104618-The%20Event%20Line-up%20for%20Each%20Session%20of%20the%20Olympic%20Games%20Tokyo%202020.pdf\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:992px;left:1103px;width:324px; height:63px;\"></div>\n        </a>\n      </div>\n\n      <div id=\"56-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/56-pop-bg.jpg\">\n        <img id=\"\" class=\"\" style=\"top:199px;left:90px;\" src=\"/111/es/static/_content/56-pop-3.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1320px; width: 169px; height: 49px;opacity:0\" onclick=\"hideOverlay('56-pop-3');\"></div>\n        <a href=\"https://fie.org/development/gear\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:718px;left:1082px;width:169px; height:33px;\"></div>\n        </a>\n      </div>\n\n      <div id=\"56-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/56-pop-bg.jpg\">\n        <img id=\"\" class=\"\" style=\"top:149px;left:126px;\" src=\"/111/es/static/_content/56-pop-4.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1320px; width: 169px; height: 49px;opacity:0\" onclick=\"hideOverlay('56-pop-4');\"></div>\n        <a href=\"http://www.NigerianFencing.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:894px;left:1249px;width:56px; height:55px;\"></div>\n        </a>\n      </div>\n\n      <div id=\"56-pop-5\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/111/es/static/_content/56-pop-bg.jpg\">\n        <img id=\"\" class=\"\" style=\"top:138px;left:81px;\" src=\"/111/es/static/_content/56-pop-5.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1320px; width: 169px; height: 49px;opacity:0\" onclick=\"hideOverlay('56-pop-5');\"></div>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax()\n          pg56Anim\n            .fromTo(cOf(\"56-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"56-logo\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"56-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg56Anim.stop();\n          hideOverlay('56-pop-1');\n          hideOverlay('56-pop-2');\n          hideOverlay('56-pop-3');\n          hideOverlay('56-pop-4');\n          hideOverlay('56-pop-5');\n          removeContentLinks();\n        }\n      ",
    "searchText": "NOTICIAS  NOTICIAS DE LA FIE  1  Los niños de Chicago prueban la esgrima Ver más aquí.  2  WWW.FIE.ORG  3  Una edición especial de Donate Your Fencing Gear! Ver más aquí.  4  Esgrima de Nigeria en marcha Ver más aquí.  5  Día Mundial de la Esgrima 2019: Esgrima para nuestro planeta Ver más aquí.  Tokio 2020 revela el programa de los Juegos Olímpicos Ver más aquí.  W W W.FIE .ORG",
    "mobileHtml": "\n        <h2>Los ni\xF1os de Chicago prueban la esgrima\n        Ver m\xE1s aqu\xED.</h2>\n        <img id=\"fwdimg\" src=\"/111/es/static/_mobile/56-1.jpg\">\n        <p>Los ni\xF1os de Chicago prueban la esgrima en el D\xEDa Ol\xEDmpico</p>\n        <p>Ni\xF1os de todas las edades en Chicago est\xE1n aprendiendo sobre esgrima por primera vez.</p>\n        <p>En el D\xEDa Ol\xEDmpico de 2019, el Club de Esgrima Junior Titans organiz\xF3 un evento para que los ni\xF1os de la zona experimentaran la esgrima. Celebrado en un lugar en el Distrito de Lemont Park, un suburbio del suroeste de la ciudad, el evento atrajo a un grupo grande y entusiasta de ni\xF1os y adolescentes que participaron. El tirador ol\xEDmpico Marek P. Stepien, que particip\xF3 en los Juegos Ol\xEDmpicos de Barcelona 1992, present\xF3 el deporte y coordin\xF3 una demostraci\xF3n de esgrima con los miembros del equipo de los Junior Titans. Los ni\xF1os que asistieron tambi\xE9n pudieron practicar juegos y ejercicios interactivos de esgrima.</p>\n\n        <h2>Tokio 2020 revela el programa de los Juegos Ol\xEDmpicos\n        Ver m\xE1s aqu\xED.</h2>\n        <p>Tokio 2020 da a conocer los detalles del programa de las pruebas de los Juegos Ol\xEDmpicos</p>\n        <p>El Comit\xE9 Organizador de los Juegos Ol\xEDmpicos y Paral\xEDmpicos de Tokio (Tokio 2020) anunci\xF3 la distribuci\xF3n del evento para cada una de las sesiones de los Juegos Ol\xEDmpicos de Tokio 2020. Esta importante informaci\xF3n ofrece algunos consejos para quienes est\xE9n pensando en comprar entradas para los Juegos Ol\xEDmpicos.</p>\n        <p>Los eventos preliminares comenzar\xE1n con el s\xF3ftbol y el f\xFAtbol femenino el 22 de julio de 2020, dos d\xEDas antes de la Ceremonia de apertura. Los eventos de remo y tiro con arco\n        se llevar\xE1n a cabo el d\xEDa de la Ceremonia de apertura. El primer evento de entrega de medallas, el rifle de aire a 10 metros femenino, se llevar\xE1 a cabo con la sesi\xF3n que comenzar\xE1 a las 8:30 JST del 25 de julio, el d\xEDa despu\xE9s de la Ceremonia de apertura. Tambi\xE9n se celebrar\xE1n eventos de medallas en seis deportes: tiro con arco, ciclismo (carrera en carretera), esgrima, judo, taekwondo y levantamiento de pesas, y se entregar\xE1n medallas en un total de 11 eventos ese d\xEDa.</p>\n        <p>Las zonas de Aomi y Ariake ser\xE1n puntos de encuentro para los deportes urbanos y es probable que resuenen con una atm\xF3sfera vibrante, destacando las innovaciones del programa deportivo destinado a hacer de Tokio 2020 \xC1More Youth, More Urban, More Women\xC8 (M\xE1s j\xF3venes, m\xE1s urbanos, m\xE1s mujeres). El baloncesto 3x3 masculino y femenino comenzar\xE1 el 25 de julio, el primer d\xEDa de los Juegos. Los eventos de skateboarding street se llevar\xE1n a cabo el 26 y 27 de julio. Los eventos de BMX Freestyle Park tendr\xE1n lugar los d\xEDas 1 y 2 de agosto, con skateboarding park los d\xEDas 5 y 6 de agosto y escalada deportiva del 4 al 7 de agosto.</p>\n        <p>Se espera que el \xC1S\xFAper S\xE1bado\xC8 y el \xC1Domingo de Oro\xC8, el 1 y 2 de agosto, atraigan a un gran n\xFAmero de espectadores de los estadios y de televidentes de todo el mundo, y que se celebre un gran n\xFAmero de eventos con medallas. Un total de 21 eventos de medallas se celebrar\xE1n el \xC1S\xFAper S\xE1bado\xC8, incluyendo eventos que se celebrar\xE1n por primera vez en los Juegos Ol\xEDmpicos, como el evento de equipo mixto de judo, el relevo de equipo mixto de triatl\xF3n y el evento de equipo mixto con trampa de tiro, todos los cuales contribuir\xE1n a convertir a Tokio 2020 en los Juegos Ol\xEDmpicos de la historia con el mayor equilibrio de g\xE9nero de todos los tiempos. En esta jornada tambi\xE9n se disputar\xE1n los cuartos de final de f\xFAtbol masculino, que se celebrar\xE1n en cuatro sedes diferentes.</p>\n\n        <h2>Una edici\xF3n especial de Donate Your Fencing Gear!\n        Ver m\xE1s aqu\xED.</h2>\n        <p>Una edici\xF3n especial de Donate Your Fencing Gear!</p>\n        <p>La FIE, en cooperaci\xF3n con la Confederaci\xF3n de Esgrima de Asia y la Federaci\xF3n Japonesa de Esgrima, llev\xF3 a cabo una edici\xF3n especial de su programa \xC1Dona tu equipo\xC8 como parte de las actividades promocionales asociadas con las Olimpiadas de Tokio 2020.</p>\n        <p>El programa recoge los equipos usados de los tiradores, as\xED como los excedentes de los fabricantes, redistribuy\xE9ndolos para apoyar los proyectos de solidaridad presentados por las federaciones miembros de la FIE. El equipo de esgrima ayuda a los atletas, entrenadores y organizaciones a reforzar la esgrima en sus respectivos pa\xEDses y permite a m\xE1s tiradores entrenar, competir y participar este deporte.</p>\n        <p>Este programa de edici\xF3n especial asegur\xF3 que las donaciones de equipo fueron redistribuidas a las federaciones de esgrima asi\xE1ticas que solicitaron el programa en 2019. La FIE anima a los clubes, atletas y federaciones de esgrima asi\xE1ticos a participar en el \xC1flujo de solidaridad\xC8 y a participar en la recogida y donaci\xF3n de material.</p>\n        <p>Kazuyasu Minobe (JPN), miembro de la Comisi\xF3n de Atletas de la FIE y representante de la Federaci\xF3n Japonesa de Esgrima, ha sido nombrado embajador del programa. Actualmente, el Sr. Minobe ocupa el segundo lugar en el mundo en la categor\xEDa de espada masculina de alto rango. El Comit\xE9 de Atletas de la Federaci\xF3n Japonesa de Esgrima dirigi\xF3 los esfuerzos de donaci\xF3n para este programa especial. Atsushi Harinishi (JPN), miembro de la Comisi\xF3n FIE SEMI, tambi\xE9n apoy\xF3 el programa en asuntos relacionados con SEMI (asegurando la integridad y est\xE1ndares de los equipos, las consideraciones de armamento, etc.).</p>\n\n        <h2>Esgrima de Nigeria en marcha\n        Ver m\xE1s aqu\xED.</h2>\n        <img id=\"fwdimg\" src=\"/111/es/static/_mobile/56-2.jpg\">\n        <p>La Federaci\xF3n Nigeriana de Esgrima inform\xF3 recientemente sobre los desarrollos y eventos, la expansi\xF3n de la esgrima en el pa\xEDs y la preparaci\xF3n para la prueba.</p>\n        <p><b>Akwa Ibom</b><br>\n        En Akwa Ibom, un estado costero del sur de Nigeria, se llev\xF3 a cabo un programa de concienciaci\xF3n y desarrollo de la esgrima, que incluy\xF3 talleres de esgrima y capacitaci\xF3n en varias escuelas e iglesias de la regi\xF3n. Comenz\xF3 en las Escuelas Pegasus, propiedad de ExxonMobil, donde m\xE1s de 250 j\xF3venes atletas fueron familiarizados con la esgrima durante varias semanas. El Club de Esgrima WOSEM, nuevo en la regi\xF3n, est\xE1 ayudando a promover los esfuerzos all\xED, y se anim\xF3 a los j\xF3venes a probar la esgrima como un deporte de toda la vida para la recreaci\xF3n, la competici\xF3n y las opciones de carrera.</p>\n        <p><b>Duelo intercolegial</b><br>\n        Las escuelas con esgrima en Lagos y sus alrededores est\xE1n intensificando el entrenamiento para un circuito competitivo intercolegial, celebrado el 29 de junio con categor\xEDas U7 y U12, que incluye una variedad de escuelas. La Escuela francesa, Rainbow College, Greensprings Schools, American International School, Children International Schools, Meadow-Hall y Priory Preparatory fueron algunas de las instituciones que participaron en el evento.</p>\n        <p><b>Preparaci\xF3n zonal de \xC1frica</b><br>\n        El Equipo Nacional de Esgrima de Nigeria se prepar\xF3 para el Campeonato Africano de Esgrima de 2019, que tuvo lugar en Bamako, Mal\xED, del 24 al 28 de junio. Uno de los eventos clasificatorios para los Juegos Ol\xEDmpicos de Tokio 2020, tambi\xE9n fue un evento preparatorio para la participaci\xF3n de Nigeria en los Campeonatos del Mundo Seniors de 2019, que se llev\xF3 a cabo en Budapest, Hungr\xEDa, del 15 al 23 de julio. Cabe destacar que la aspirante ol\xEDmpica y competidora femenina de sable, Blessing Olaode, es una de las mejores tiradoras de Nigeria en entrenamiento para el a\xF1o que viene</p>\n        <p>La Federaci\xF3n Nigeriana de Esgrima anima a los interesados en obtener m\xE1s informaci\xF3n a visitar su sitio web, <a href=\"http://www.NigerianFencing.com\" target=\"_blank\">www.NigerianFencing.com.</a></p>\n\n        <h2>D\xEDa Mundial de la Esgrima 2019: Esgrima para nuestro planeta Ver m\xE1s aqu\xED.</h2>\n        <p>La Federaci\xF3n Internacional de Esgrima (FIE) se complace en anunciar que el tema del D\xEDa Mundial de la Esgrima 2019 (s\xE1bado, 7 de septiembre) es \xC1Esgrima para nuestro planeta\xC8.</p>\n\n        <p>Como parte de su misi\xF3n y principios b\xE1sicos, la FIE animar\xE1 a los atletas, entrenadores, clubes y federaciones de esgrima de todo el mundo a demostrar no solo su amor por el deporte de la esgrima, sino tambi\xE9n a utilizar sus talentos y su dedicaci\xF3n al deporte para el mejoramiento de sus comunidades y de nuestro entorno com\xFAn.</p>\n\n        <p>Desde la primera edici\xF3n en 2017 del D\xEDa Mundial de la Esgrima, esgrimistas, entrenadores, clubes y federaciones se re\xFAnen en lugares p\xFAblicos en forma masiva para demostrar de manera creativa e innovadora el deporte al p\xFAblico. Hoy, la FIE pide a la comunidad de esgrima que demuestre los valores y principios b\xE1sicos de la tradici\xF3n de esgrima en beneficio de sus comunidades. Demostrar la importancia de la buena condici\xF3n f\xEDsica y la nutrici\xF3n a los grupos de j\xF3venes en zonas desfavorecidas y a los adultos mayores, unirse a grupos de voluntarios para ayudar a limpiar las playas y los lugares en peligro de extinci\xF3n, y proporcionar ayuda a los m\xE1s vulnerables de nuestra sociedad, son algunas de las maneras en las que los esgrimistas, los clubes y las federaciones de esgrima, pueden utilizar la gran red de energ\xEDa de la esgrima en pro del mejoramiento de las personas que est\xE1n alrededor de ellas.</p>\n\n        <p>Al hacerlo, la FIE espera que los esgrimistas puedan demostrar al mundo que la esgrima no es solo un deporte, sino un estado de \xE1nimo positivo que puede beneficiar tanto a los individuos como a las comunidades en las que viven.</p>\n\n        <p>En el D\xEDa Mundial de la Esgrima, el tema \xC1Esgrima para nuestro planeta\xC8 es un llamado a la acci\xF3n para que la familia mundial de esgrima demuestre que la esgrima y los esgrimistas se preocupan por las personas y por el mundo.</p>\n\n        <p>El D\xEDa Mundial de la Esgrima se celebra el segundo s\xE1bado de septiembre de cada a\xF1o, donde federaciones, esgrimistas y entrenadores de todos los niveles (desde los campeones ol\xEDmpicos y mundiales de esgrima hasta los clubes locales) se re\xFAnen para celebrar el deporte de la esgrima en cualquier comunidad para que la gente descubra el deporte, su historia y sus valores. Muchas de las 153 federaciones miembros de la FIE participan en la organizaci\xF3n de actividades para transmitir el mensaje de la esgrima: La esgrima es un deporte para el cuerpo, la mente y el esp\xEDritu con un legado e una historia impresionantes, as\xED como una dedicaci\xF3n al juego limpio, al respeto y al deporte para todos.</p>\n        "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/111/es/static/_mobile/57.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 58-title\" style=\"top:88px;left:86px\" src=\"/111/es/static/_content/58-title.png\">\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax()\n          pg58Anim\n            .fromTo(cOf(\"58-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop()\n        }\n      ",
    "searchText": "RECUERDO  NECROLÓGICAS André Pinelli Recibimos con gran tristeza la noticia del fallecimiento de André Pinellli, un gran amante de la esgrima que dedicó gran parte de su vida al desarrollo de este deporte. Su compromiso como dirigente comenzó en el sur de Francia, donde fue presidente de la Liga de Provenza de 1973 a 1993. Más tarde, a partir de 1977, asumió responsabilidades en la Federación francesa de esgrima, de la que fue vicepresidente desde 1984 hasta 2005. André Pinelli siempre contó con el apoyo de las personas que tuvieron la suerte de conocerlo y seguirá dejando huella en el mundo de la  esgrima; a él debemos la construcción de la sala de armas de Cabriès y la del CREPS de Aix-en-Provence. Nacido en 1922, participó activamente en la liberación de Francia al desembarcar en Saint-Tropez al final de la Segunda Guerra Mundial y fue condecorado con la Legión de Honor en 2005. Nos dejó el 25 de marzo a la edad de 97 años. Queremos expresar nuestro más sentido pésame a su familia. ■  W W W.FIE .ORG",
    "mobileHtml": "\n      <h2>Andr\xE9 Pinelli</h2>\n      <p>Recibimos con gran tristeza la noticia del fallecimiento de Andr\xE9 Pinellli, un gran amante de la esgrima que dedic\xF3 gran parte de su vida al desarrollo de este deporte.</p>\n      <p>Su compromiso como dirigente comenz\xF3 en el sur de Francia, donde fue presidente de la Liga de Provenza de 1973 a 1993. M\xE1s tarde, a partir de 1977, asumi\xF3 responsabilidades en la Federaci\xF3n francesa de esgrima, de la que fue vicepresidente desde 1984 hasta 2005. Andr\xE9 Pinelli siempre cont\xF3 con el apoyo de las personas que tuvieron la suerte de conocerlo y seguir\xE1 dejando huella en el mundo de la esgrima; a \xE9l debemos la construcci\xF3n de la sala de armas de Cabri\x8Fs y la del CREPS de Aix-en-Provence.</p>\n      <p>Nacido en 1922, particip\xF3 activamente en la liberaci\xF3n de Francia al desembarcar en Saint-Tropez al final de la Segunda Guerra Mundial y fue condecorado con la Legi\xF3n de Honor en 2005. Nos dej\xF3 el 25 de marzo a la edad de 97 a\xF1os.</p>\n      <p>Queremos expresar nuestro m\xE1s sentido p\xE9same a su familia.</p>\n      "
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function toggleCategory(id, klass) {\n        var category = idOf(id);\n        console.log(category)\n        var categories = cOf(klass);\n        console.log(categories)\n        for(i=0; i < categories.length; i++){\n          categories[i].style.opacity = 0;\n        }\n        category.style.opacity = 1;\n      }\n    ",
  "mobilePages": [{
    "title": "Escrime XXI N⁰. 111",
    "cssClass": "cover mobile-p1",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 0,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 2,
      "subIndex": 0
    }]
  }, {
    "title": "Comité Ejecutivo de la FIE",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 4,
      "subIndex": 0
    }]
  }, {
    "title": "Prólogo",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 5,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 6,
      "subIndex": 0
    }]
  }, {
    "title": "Campeonatos del mundo de Esgrima júnior y cadete",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 7,
      "subIndex": 0
    }, {
      "index": 8,
      "subIndex": 0
    }, {
      "index": 9,
      "subIndex": 0
    }]
  }, {
    "title": "Gran Premio",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 10,
      "subIndex": 0
    }, {
      "index": 11,
      "subIndex": 0
    }, {
      "index": 12,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 13,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 14,
      "subIndex": 0
    }]
  }, {
    "title": "COPA DEL MUNDO",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 15,
      "subIndex": 0
    }, {
      "index": 16,
      "subIndex": 0
    }, {
      "index": 17,
      "subIndex": 0
    }]
  }, {
    "title": "Campeonatos zonales de Esgrima",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 18,
      "subIndex": 0
    }, {
      "index": 19,
      "subIndex": 0
    }, {
      "index": 20,
      "subIndex": 0
    }, {
      "index": 21,
      "subIndex": 0
    }, {
      "index": 22,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 23,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 24,
      "subIndex": 0
    }]
  }, {
    "title": "Campeonato del mundo",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 25,
      "subIndex": 0
    }, {
      "index": 26,
      "subIndex": 0
    }, {
      "index": 27,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 28,
      "subIndex": 0
    }]
  }, {
    "title": "Conozca a los Atletas",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 29,
      "subIndex": 0
    }, {
      "index": 30,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales- Seguridad",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 31,
      "subIndex": 0
    }, {
      "index": 32,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 33,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 34,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - #Whitecard",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 35,
      "subIndex": 0
    }, {
      "index": 36,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - Play True De La Amae",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 37,
      "subIndex": 0
    }, {
      "index": 38,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 39,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 40,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - Programa Donate Your Fencing Gear",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 41,
      "subIndex": 0
    }, {
      "index": 42,
      "subIndex": 0
    }, {
      "index": 43,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - FIE Commissions",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 44,
      "subIndex": 0
    }, {
      "index": 45,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - Nepal",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 46,
      "subIndex": 0
    }, {
      "index": 47,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 48,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - Samoa",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 49,
      "subIndex": 0
    }, {
      "index": 50,
      "subIndex": 0
    }, {
      "index": 51,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales - Stand De Juego Limpio En Torun",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 52,
      "subIndex": 0
    }, {
      "index": 53,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 54,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias",
    "cssClass": "yellow",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 55,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 56,
      "subIndex": 0
    }]
  }, {
    "title": "Necrológicas",
    "cssClass": "grey",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 57,
      "subIndex": 0
    }]
  }],
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-29',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SU9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bMw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.691eff45e8d5d5ae8663.js